export const dpk_trade_metrics = {
  id: 5,
  overall_metrics: {
    nifty: 764570.5,
    stock: 2819315.75,
    banknifty: -83863.25,
    total_pnl: 3500023.0,
    win_ratio: 0.38,
    expectancy: 3922.82,
    volatility: 115098.4,
    payoff_ratio: 2.72,
    sharpe_ratio: 0.14,
    total_trades: 3457,
    profit_factor: 1.7,
    sortino_ratio: 0.4,
    total_loss_days: 162,
    maximum_drawdown: -1.01,
    risk_reward_ratio: 2.72,
    total_trading_days: 263,
    total_winning_days: 101,
    avg_loss_day_percent: 0.89,
    total_pnl_in_percent: 350.0,
    avg_loss_on_loss_days: -31052.94,
    total_negative_trades: 2278,
    total_positive_trades: 1168,
    avg_profit_on_win_days: 84461.39,
    max_losing_streak_days: 14,
    avg_winning_day_percent: 2.41,
    max_winning_streak_days: 8,
    accuracy_days_in_percent: 38.4,
    accuracy_trades_in_percent: 33.79,
    avg_monthly_return_in_percent: 350.0,
  },
  
  day_wise_pnl: [
    {
      pnl: 1129.0,
      date: "01-08-2023",
    },
    {
      pnl: -1260.0,
      date: "02-08-2023",
    },
    {
      pnl: -4250.0,
      date: "04-08-2023",
    },
    {
      pnl: -760.0,
      date: "07-08-2023",
    },
    {
      pnl: 1005.0,
      date: "08-08-2023",
    },
    {
      pnl: -2444.0,
      date: "09-08-2023",
    },
    {
      pnl: 687.0,
      date: "10-08-2023",
    },
    {
      pnl: -525.0,
      date: "17-08-2023",
    },
    {
      pnl: -10725.0,
      date: "18-08-2023",
    },
    {
      pnl: -343.0,
      date: "30-08-2023",
    },
    {
      pnl: -50.0,
      date: "31-08-2023",
    },
    {
      pnl: -2228.0,
      date: "01-09-2023",
    },
    {
      pnl: -263.0,
      date: "05-09-2023",
    },
    {
      pnl: 140.0,
      date: "06-09-2023",
    },
    {
      pnl: -407.0,
      date: "07-09-2023",
    },
    {
      pnl: -1254.0,
      date: "08-09-2023",
    },
    {
      pnl: 613.0,
      date: "11-09-2023",
    },
    {
      pnl: 45611.0,
      date: "12-09-2023",
    },
    {
      pnl: 5399.0,
      date: "13-09-2023",
    },
    {
      pnl: 1766.0,
      date: "14-09-2023",
    },
    {
      pnl: -4999.0,
      date: "15-09-2023",
    },
    {
      pnl: -2522.0,
      date: "18-09-2023",
    },
    {
      pnl: 1278.0,
      date: "20-09-2023",
    },
    {
      pnl: -135.0,
      date: "21-09-2023",
    },
    {
      pnl: 18.0,
      date: "22-09-2023",
    },
    {
      pnl: -5577.0,
      date: "25-09-2023",
    },
    {
      pnl: -2820.0,
      date: "26-09-2023",
    },
    {
      pnl: -3814.0,
      date: "27-09-2023",
    },
    {
      pnl: 21801.0,
      date: "28-09-2023",
    },
    {
      pnl: -759.0,
      date: "29-09-2023",
    },
    {
      pnl: -2712.0,
      date: "03-10-2023",
    },
    {
      pnl: -6801.0,
      date: "04-10-2023",
    },
    {
      pnl: -2162.0,
      date: "05-10-2023",
    },
    {
      pnl: -662.0,
      date: "06-10-2023",
    },
    {
      pnl: 519.0,
      date: "09-10-2023",
    },
    {
      pnl: 45.0,
      date: "10-10-2023",
    },
    {
      pnl: -3476.0,
      date: "11-10-2023",
    },
    {
      pnl: -220.0,
      date: "12-10-2023",
    },
    {
      pnl: 2750.0,
      date: "13-10-2023",
    },
    {
      pnl: -2120.0,
      date: "16-10-2023",
    },
    {
      pnl: 615.0,
      date: "17-10-2023",
    },
    {
      pnl: 5616.0,
      date: "18-10-2023",
    },
    {
      pnl: 2317.0,
      date: "19-10-2023",
    },
    {
      pnl: -625.0,
      date: "20-10-2023",
    },
    {
      pnl: 4704.0,
      date: "23-10-2023",
    },
    {
      pnl: 104761.0,
      date: "25-10-2023",
    },
    {
      pnl: -2824.0,
      date: "26-10-2023",
    },
    {
      pnl: -3869.0,
      date: "31-10-2023",
    },
    {
      pnl: -788.0,
      date: "01-11-2023",
    },
    {
      pnl: -7260.0,
      date: "02-11-2023",
    },
    {
      pnl: -859.0,
      date: "03-11-2023",
    },
    {
      pnl: -8573.0,
      date: "07-11-2023",
    },
    {
      pnl: -7505.0,
      date: "08-11-2023",
    },
    {
      pnl: -2911.0,
      date: "09-11-2023",
    },
    {
      pnl: -1775.0,
      date: "10-11-2023",
    },
    {
      pnl: -837.0,
      date: "13-11-2023",
    },
    {
      pnl: -428.0,
      date: "15-11-2023",
    },
    {
      pnl: -2150.0,
      date: "16-11-2023",
    },
    {
      pnl: -1649.0,
      date: "17-11-2023",
    },
    {
      pnl: -4145.0,
      date: "20-11-2023",
    },
    {
      pnl: 2010.0,
      date: "21-11-2023",
    },
    {
      pnl: 1483.0,
      date: "22-11-2023",
    },
    {
      pnl: -2175.0,
      date: "23-11-2023",
    },
    {
      pnl: 76069.0,
      date: "30-11-2023",
    },
    {
      pnl: 4264.0,
      date: "01-12-2023",
    },
    {
      pnl: 85.0,
      date: "05-12-2023",
    },
    {
      pnl: 87821.0,
      date: "06-12-2023",
    },
    {
      pnl: 2694.0,
      date: "07-12-2023",
    },
    {
      pnl: 276.0,
      date: "08-12-2023",
    },
    {
      pnl: -1796.0,
      date: "12-12-2023",
    },
    {
      pnl: -2090.0,
      date: "13-12-2023",
    },
    {
      pnl: 9098.0,
      date: "14-12-2023",
    },
    {
      pnl: 179971.0,
      date: "15-12-2023",
    },
    {
      pnl: -4218.0,
      date: "16-12-2023",
    },
    {
      pnl: -6676.0,
      date: "18-12-2023",
    },
    {
      pnl: -32769.0,
      date: "19-12-2023",
    },
    {
      pnl: -69530.0,
      date: "20-12-2023",
    },
    {
      pnl: 46443.0,
      date: "21-12-2023",
    },
    {
      pnl: -16982.0,
      date: "22-12-2023",
    },
    {
      pnl: -6890.0,
      date: "26-12-2023",
    },
    {
      pnl: -12802.0,
      date: "27-12-2023",
    },
    {
      pnl: -169.0,
      date: "28-12-2023",
    },
    {
      pnl: -4277.0,
      date: "01-01-2024",
    },
    {
      pnl: 2730.0,
      date: "02-01-2024",
    },
    {
      pnl: -5104.0,
      date: "03-01-2024",
    },
    {
      pnl: -8508.0,
      date: "04-01-2024",
    },
    {
      pnl: -19240.0,
      date: "05-01-2024",
    },
    {
      pnl: -14318.0,
      date: "09-01-2024",
    },
    {
      pnl: 18393.0,
      date: "10-01-2024",
    },
    {
      pnl: -9868.0,
      date: "11-01-2024",
    },
    {
      pnl: -28633.0,
      date: "12-01-2024",
    },
    {
      pnl: -3068.0,
      date: "15-01-2024",
    },
    {
      pnl: 58830.0,
      date: "16-01-2024",
    },
    {
      pnl: 94404.0,
      date: "17-01-2024",
    },
    {
      pnl: -5300.0,
      date: "19-01-2024",
    },
    {
      pnl: -65068.0,
      date: "20-01-2024",
    },
    {
      pnl: -6497.0,
      date: "23-01-2024",
    },
    {
      pnl: 23826.0,
      date: "24-01-2024",
    },
    {
      pnl: -34977.0,
      date: "25-01-2024",
    },
    {
      pnl: -7664.0,
      date: "29-01-2024",
    },
    {
      pnl: 8611.0,
      date: "30-01-2024",
    },
    {
      pnl: 57947.0,
      date: "31-01-2024",
    },
    {
      pnl: -60800.0,
      date: "01-02-2024",
    },
    {
      pnl: -38791.0,
      date: "02-02-2024",
    },
    {
      pnl: 76011.0,
      date: "05-02-2024",
    },
    {
      pnl: -1713.0,
      date: "06-02-2024",
    },
    {
      pnl: 17815.0,
      date: "07-02-2024",
    },
    {
      pnl: 6452.0,
      date: "08-02-2024",
    },
    {
      pnl: -15317.0,
      date: "09-02-2024",
    },
    {
      pnl: -94868.0,
      date: "12-02-2024",
    },
    {
      pnl: -11087.0,
      date: "13-02-2024",
    },
    {
      pnl: -28489.0,
      date: "14-02-2024",
    },
    {
      pnl: 74963.0,
      date: "15-02-2024",
    },
    {
      pnl: 37547.0,
      date: "16-02-2024",
    },
    {
      pnl: -53555.0,
      date: "19-02-2024",
    },
    {
      pnl: -33492.0,
      date: "20-02-2024",
    },
    {
      pnl: 36169.0,
      date: "21-02-2024",
    },
    {
      pnl: 17674.0,
      date: "22-02-2024",
    },
    {
      pnl: 17644.0,
      date: "23-02-2024",
    },
    {
      pnl: -8209.0,
      date: "26-02-2024",
    },
    {
      pnl: -11149.0,
      date: "27-02-2024",
    },
    {
      pnl: 8153.0,
      date: "28-02-2024",
    },
    {
      pnl: -25688.0,
      date: "29-02-2024",
    },
    {
      pnl: -5623.0,
      date: "01-03-2024",
    },
    {
      pnl: 13098.0,
      date: "04-03-2024",
    },
    {
      pnl: -18198.0,
      date: "05-03-2024",
    },
    {
      pnl: -8782.0,
      date: "06-03-2024",
    },
    {
      pnl: -38228.0,
      date: "07-03-2024",
    },
    {
      pnl: 96998.0,
      date: "11-03-2024",
    },
    {
      pnl: -76030.0,
      date: "12-03-2024",
    },
    {
      pnl: -98508.0,
      date: "15-03-2024",
    },
    {
      pnl: -64997.0,
      date: "18-03-2024",
    },
    {
      pnl: -11611.0,
      date: "19-03-2024",
    },
    {
      pnl: -71363.0,
      date: "20-03-2024",
    },
    {
      pnl: 50056.0,
      date: "21-03-2024",
    },
    {
      pnl: 201689.0,
      date: "22-03-2024",
    },
    {
      pnl: -2304.0,
      date: "27-03-2024",
    },
    {
      pnl: 57197.0,
      date: "28-03-2024",
    },
    {
      pnl: -7569.0,
      date: "02-04-2024",
    },
    {
      pnl: 87632.0,
      date: "03-04-2024",
    },
    {
      pnl: 70793.0,
      date: "04-04-2024",
    },
    {
      pnl: -60282.0,
      date: "05-04-2024",
    },
    {
      pnl: 11911.0,
      date: "08-04-2024",
    },
    {
      pnl: -45851.0,
      date: "09-04-2024",
    },
    {
      pnl: -18214.0,
      date: "10-04-2024",
    },
    {
      pnl: 22053.0,
      date: "12-04-2024",
    },
    {
      pnl: -71621.0,
      date: "15-04-2024",
    },
    {
      pnl: -29260.0,
      date: "16-04-2024",
    },
    {
      pnl: 44004.0,
      date: "18-04-2024",
    },
    {
      pnl: 41208.0,
      date: "19-04-2024",
    },
    {
      pnl: 6672.0,
      date: "22-04-2024",
    },
    {
      pnl: 10000.0,
      date: "23-04-2024",
    },
    {
      pnl: -11583.0,
      date: "24-04-2024",
    },
    {
      pnl: 43255.0,
      date: "25-04-2024",
    },
    {
      pnl: -7492.0,
      date: "26-04-2024",
    },
    {
      pnl: -4742.0,
      date: "29-04-2024",
    },
    {
      pnl: -39133.0,
      date: "30-04-2024",
    },
    {
      pnl: -26910.0,
      date: "02-05-2024",
    },
    {
      pnl: 3028.0,
      date: "03-05-2024",
    },
    {
      pnl: -5522.0,
      date: "06-05-2024",
    },
    {
      pnl: -68897.0,
      date: "07-05-2024",
    },
    {
      pnl: -10555.0,
      date: "08-05-2024",
    },
    {
      pnl: -26616.0,
      date: "09-05-2024",
    },
    {
      pnl: 12203.0,
      date: "10-05-2024",
    },
    {
      pnl: -152513.0,
      date: "13-05-2024",
    },
    {
      pnl: 11001.0,
      date: "14-05-2024",
    },
    {
      pnl: 76735.0,
      date: "15-05-2024",
    },
    {
      pnl: 202782.0,
      date: "16-05-2024",
    },
    {
      pnl: 15040.0,
      date: "17-05-2024",
    },
    {
      pnl: 60705.0,
      date: "18-05-2024",
    },
    {
      pnl: 369154.0,
      date: "21-05-2024",
    },
    {
      pnl: 165986.0,
      date: "22-05-2024",
    },
    {
      pnl: 742764.0,
      date: "23-05-2024",
    },
    {
      pnl: -40247.0,
      date: "24-05-2024",
    },
    {
      pnl: 62217.0,
      date: "27-05-2024",
    },
    {
      pnl: -5121.0,
      date: "28-05-2024",
    },
    {
      pnl: -12192.0,
      date: "29-05-2024",
    },
    {
      pnl: -25637.0,
      date: "30-05-2024",
    },
    {
      pnl: 3817.0,
      date: "31-05-2024",
    },
    {
      pnl: 28784.0,
      date: "03-06-2024",
    },
    {
      pnl: -237886.0,
      date: "04-06-2024",
    },
    {
      pnl: -6525.0,
      date: "05-06-2024",
    },
    {
      pnl: -31568.0,
      date: "06-06-2024",
    },
    {
      pnl: 86134.0,
      date: "07-06-2024",
    },
    {
      pnl: 136893.0,
      date: "10-06-2024",
    },
    {
      pnl: -54528.0,
      date: "11-06-2024",
    },
    {
      pnl: -122721.0,
      date: "12-06-2024",
    },
    {
      pnl: -48720.0,
      date: "13-06-2024",
    },
    {
      pnl: 748622.0,
      date: "14-06-2024",
    },
    {
      pnl: 551425.0,
      date: "18-06-2024",
    },
    {
      pnl: -38481.0,
      date: "19-06-2024",
    },
    {
      pnl: -14120.0,
      date: "20-06-2024",
    },
    {
      pnl: -53788.0,
      date: "21-06-2024",
    },
    {
      pnl: -15130.0,
      date: "22-06-2024",
    },
    {
      pnl: -60029.0,
      date: "24-06-2024",
    },
    {
      pnl: -14387.0,
      date: "25-06-2024",
    },
    {
      pnl: 4208.0,
      date: "26-06-2024",
    },
    {
      pnl: -11747.0,
      date: "27-06-2024",
    },
    {
      pnl: 35380.0,
      date: "28-06-2024",
    },
    {
      pnl: 22294.0,
      date: "01-07-2024",
    },
    {
      pnl: 27438.0,
      date: "02-07-2024",
    },
    {
      pnl: -28409.0,
      date: "03-07-2024",
    },
    {
      pnl: -7416.0,
      date: "04-07-2024",
    },
    {
      pnl: 130470.0,
      date: "05-07-2024",
    },
    {
      pnl: 65943.0,
      date: "08-07-2024",
    },
    {
      pnl: -17890.0,
      date: "09-07-2024",
    },
    {
      pnl: -42193.0,
      date: "10-07-2024",
    },
    {
      pnl: -34344.0,
      date: "11-07-2024",
    },
    {
      pnl: -7478.0,
      date: "12-07-2024",
    },
    {
      pnl: -63642.0,
      date: "15-07-2024",
    },
    {
      pnl: 64397.0,
      date: "16-07-2024",
    },
    {
      pnl: -32429.0,
      date: "18-07-2024",
    },
    {
      pnl: -79944.0,
      date: "19-07-2024",
    },
    {
      pnl: 51717.0,
      date: "22-07-2024",
    },
    {
      pnl: -59769.0,
      date: "23-07-2024",
    },
    {
      pnl: -147250.0,
      date: "24-07-2024",
    },
    {
      pnl: -35216.0,
      date: "25-07-2024",
    },
    {
      pnl: -31436.0,
      date: "26-07-2024",
    },
    {
      pnl: 72533.0,
      date: "29-07-2024",
    },
    {
      pnl: 52577.0,
      date: "30-07-2024",
    },
    {
      pnl: -10056.0,
      date: "31-07-2024",
    },
    {
      pnl: -37344.0,
      date: "01-08-2024",
    },
    {
      pnl: -172542.0,
      date: "02-08-2024",
    },
    {
      pnl: 114290.0,
      date: "05-08-2024",
    },
    {
      pnl: -77763.0,
      date: "06-08-2024",
    },
    {
      pnl: -16783.0,
      date: "07-08-2024",
    },
    {
      pnl: -175741.0,
      date: "08-08-2024",
    },
    {
      pnl: -23075.0,
      date: "09-08-2024",
    },
    {
      pnl: 50482.8,
      date: "12-08-2024",
    },
    {
      pnl: -87859.25,
      date: "13-08-2024",
    },
    {
      pnl: -47712.0,
      date: "14-08-2024",
    },
    {
      pnl: -45617.5,
      date: "16-08-2024",
    },
    {
      pnl: 75274.0,
      date: "19-08-2024",
    },
    {
      pnl: 89316.25,
      date: "20-08-2024",
    },
    {
      pnl: 256887.5,
      date: "21-08-2024",
    },
    {
      pnl: -86784.15,
      date: "22-08-2024",
    },
    {
      pnl: 908030.0,
      date: "23-08-2024",
    },
    {
      pnl: -11821.25,
      date: "26-08-2024",
    },
    {
      pnl: -58027.8,
      date: "27-08-2024",
    },
    {
      pnl: 107936.45,
      date: "28-08-2024",
    },
    {
      pnl: -22760.0,
      date: "29-08-2024",
    },
    {
      pnl: 53379.75,
      date: "30-08-2024",
    },
    {
      pnl: -42509.0,
      date: "02-09-2024",
    },
    {
      pnl: -93806.5,
      date: "03-09-2024",
    },
    {
      pnl: -57287.5,
      date: "04-09-2024",
    },
    {
      pnl: -16142.4,
      date: "05-09-2024",
    },
    {
      pnl: -84956.25,
      date: "06-09-2024",
    },
    {
      pnl: -34511.75,
      date: "09-09-2024",
    },
    {
      pnl: -68741.25,
      date: "10-09-2024",
    },
    {
      pnl: 140776.85,
      date: "11-09-2024",
    },
    {
      pnl: -9769.25,
      date: "12-09-2024",
    },
    {
      pnl: 193231.75,
      date: "13-09-2024",
    },
    {
      pnl: 380395.3,
      date: "16-09-2024",
    },
    {
      pnl: -133348.65,
      date: "17-09-2024",
    },
    {
      pnl: -42580.25,
      date: "18-09-2024",
    },
    {
      pnl: -109792.25,
      date: "19-09-2024",
    },
    {
      pnl: 298525.55,
      date: "20-09-2024",
    },
    {
      pnl: 22683.75,
      date: "23-09-2024",
    },
    {
      pnl: -21999.3,
      date: "24-09-2024",
    },
    {
      pnl: 110420.0,
      date: "25-09-2024",
    },
    {
      pnl: -53650.55,
      date: "26-09-2024",
    },
    {
      pnl: -34866.25,
      date: "27-09-2024",
    },
    {
      pnl: -128819.85,
      date: "30-09-2024",
    },
  ],

  cumulative_pnl: [
    {
      date: "31-07-2023",
      cumulative_pnl: 1000000.0,
    },
    {
      date: "01-08-2023",
      cumulative_pnl: 1001129.0,
    },
    {
      date: "02-08-2023",
      cumulative_pnl: 999869.0,
    },
    {
      date: "04-08-2023",
      cumulative_pnl: 995619.0,
    },
    {
      date: "07-08-2023",
      cumulative_pnl: 994859.0,
    },
    {
      date: "08-08-2023",
      cumulative_pnl: 995864.0,
    },
    {
      date: "09-08-2023",
      cumulative_pnl: 993420.0,
    },
    {
      date: "10-08-2023",
      cumulative_pnl: 994107.0,
    },
    {
      date: "17-08-2023",
      cumulative_pnl: 993582.0,
    },
    {
      date: "18-08-2023",
      cumulative_pnl: 982857.0,
    },
    {
      date: "30-08-2023",
      cumulative_pnl: 982514.0,
    },
    {
      date: "31-08-2023",
      cumulative_pnl: 982464.0,
    },
    {
      date: "01-09-2023",
      cumulative_pnl: 980236.0,
    },
    {
      date: "05-09-2023",
      cumulative_pnl: 979973.0,
    },
    {
      date: "06-09-2023",
      cumulative_pnl: 980113.0,
    },
    {
      date: "07-09-2023",
      cumulative_pnl: 979706.0,
    },
    {
      date: "08-09-2023",
      cumulative_pnl: 978452.0,
    },
    {
      date: "11-09-2023",
      cumulative_pnl: 979065.0,
    },
    {
      date: "12-09-2023",
      cumulative_pnl: 1024676.0,
    },
    {
      date: "13-09-2023",
      cumulative_pnl: 1030075.0,
    },
    {
      date: "14-09-2023",
      cumulative_pnl: 1031841.0,
    },
    {
      date: "15-09-2023",
      cumulative_pnl: 1026842.0,
    },
    {
      date: "18-09-2023",
      cumulative_pnl: 1024320.0,
    },
    {
      date: "20-09-2023",
      cumulative_pnl: 1025598.0,
    },
    {
      date: "21-09-2023",
      cumulative_pnl: 1025463.0,
    },
    {
      date: "22-09-2023",
      cumulative_pnl: 1025481.0,
    },
    {
      date: "25-09-2023",
      cumulative_pnl: 1019904.0,
    },
    {
      date: "26-09-2023",
      cumulative_pnl: 1017084.0,
    },
    {
      date: "27-09-2023",
      cumulative_pnl: 1013270.0,
    },
    {
      date: "28-09-2023",
      cumulative_pnl: 1035071.0,
    },
    {
      date: "29-09-2023",
      cumulative_pnl: 1034312.0,
    },
    {
      date: "03-10-2023",
      cumulative_pnl: 1031600.0,
    },
    {
      date: "04-10-2023",
      cumulative_pnl: 1024799.0,
    },
    {
      date: "05-10-2023",
      cumulative_pnl: 1022637.0,
    },
    {
      date: "06-10-2023",
      cumulative_pnl: 1021975.0,
    },
    {
      date: "09-10-2023",
      cumulative_pnl: 1022494.0,
    },
    {
      date: "10-10-2023",
      cumulative_pnl: 1022539.0,
    },
    {
      date: "11-10-2023",
      cumulative_pnl: 1019063.0,
    },
    {
      date: "12-10-2023",
      cumulative_pnl: 1018843.0,
    },
    {
      date: "13-10-2023",
      cumulative_pnl: 1021593.0,
    },
    {
      date: "16-10-2023",
      cumulative_pnl: 1019473.0,
    },
    {
      date: "17-10-2023",
      cumulative_pnl: 1020088.0,
    },
    {
      date: "18-10-2023",
      cumulative_pnl: 1025704.0,
    },
    {
      date: "19-10-2023",
      cumulative_pnl: 1028021.0,
    },
    {
      date: "20-10-2023",
      cumulative_pnl: 1027396.0,
    },
    {
      date: "23-10-2023",
      cumulative_pnl: 1032100.0,
    },
    {
      date: "25-10-2023",
      cumulative_pnl: 1136861.0,
    },
    {
      date: "26-10-2023",
      cumulative_pnl: 1134037.0,
    },
    {
      date: "31-10-2023",
      cumulative_pnl: 1130168.0,
    },
    {
      date: "01-11-2023",
      cumulative_pnl: 1129380.0,
    },
    {
      date: "02-11-2023",
      cumulative_pnl: 1122120.0,
    },
    {
      date: "03-11-2023",
      cumulative_pnl: 1121261.0,
    },
    {
      date: "07-11-2023",
      cumulative_pnl: 1112688.0,
    },
    {
      date: "08-11-2023",
      cumulative_pnl: 1105183.0,
    },
    {
      date: "09-11-2023",
      cumulative_pnl: 1102272.0,
    },
    {
      date: "10-11-2023",
      cumulative_pnl: 1100497.0,
    },
    {
      date: "13-11-2023",
      cumulative_pnl: 1099660.0,
    },
    {
      date: "15-11-2023",
      cumulative_pnl: 1099232.0,
    },
    {
      date: "16-11-2023",
      cumulative_pnl: 1097082.0,
    },
    {
      date: "17-11-2023",
      cumulative_pnl: 1095433.0,
    },
    {
      date: "20-11-2023",
      cumulative_pnl: 1091288.0,
    },
    {
      date: "21-11-2023",
      cumulative_pnl: 1093298.0,
    },
    {
      date: "22-11-2023",
      cumulative_pnl: 1094781.0,
    },
    {
      date: "23-11-2023",
      cumulative_pnl: 1092606.0,
    },
    {
      date: "30-11-2023",
      cumulative_pnl: 1168675.0,
    },
    {
      date: "01-12-2023",
      cumulative_pnl: 1172939.0,
    },
    {
      date: "05-12-2023",
      cumulative_pnl: 1173024.0,
    },
    {
      date: "06-12-2023",
      cumulative_pnl: 1260845.0,
    },
    {
      date: "07-12-2023",
      cumulative_pnl: 1263539.0,
    },
    {
      date: "08-12-2023",
      cumulative_pnl: 1263815.0,
    },
    {
      date: "12-12-2023",
      cumulative_pnl: 1262019.0,
    },
    {
      date: "13-12-2023",
      cumulative_pnl: 1259929.0,
    },
    {
      date: "14-12-2023",
      cumulative_pnl: 1269027.0,
    },
    {
      date: "15-12-2023",
      cumulative_pnl: 1448998.0,
    },
    {
      date: "16-12-2023",
      cumulative_pnl: 1444780.0,
    },
    {
      date: "18-12-2023",
      cumulative_pnl: 1438104.0,
    },
    {
      date: "19-12-2023",
      cumulative_pnl: 1405335.0,
    },
    {
      date: "20-12-2023",
      cumulative_pnl: 1335805.0,
    },
    {
      date: "21-12-2023",
      cumulative_pnl: 1382248.0,
    },
    {
      date: "22-12-2023",
      cumulative_pnl: 1365266.0,
    },
    {
      date: "26-12-2023",
      cumulative_pnl: 1358376.0,
    },
    {
      date: "27-12-2023",
      cumulative_pnl: 1345574.0,
    },
    {
      date: "28-12-2023",
      cumulative_pnl: 1345405.0,
    },
    {
      date: "01-01-2024",
      cumulative_pnl: 1341128.0,
    },
    {
      date: "02-01-2024",
      cumulative_pnl: 1343858.0,
    },
    {
      date: "03-01-2024",
      cumulative_pnl: 1338754.0,
    },
    {
      date: "04-01-2024",
      cumulative_pnl: 1330246.0,
    },
    {
      date: "05-01-2024",
      cumulative_pnl: 1311006.0,
    },
    {
      date: "09-01-2024",
      cumulative_pnl: 1296688.0,
    },
    {
      date: "10-01-2024",
      cumulative_pnl: 1315081.0,
    },
    {
      date: "11-01-2024",
      cumulative_pnl: 1305213.0,
    },
    {
      date: "12-01-2024",
      cumulative_pnl: 1276580.0,
    },
    {
      date: "15-01-2024",
      cumulative_pnl: 1273512.0,
    },
    {
      date: "16-01-2024",
      cumulative_pnl: 1332342.0,
    },
    {
      date: "17-01-2024",
      cumulative_pnl: 1426746.0,
    },
    {
      date: "19-01-2024",
      cumulative_pnl: 1421446.0,
    },
    {
      date: "20-01-2024",
      cumulative_pnl: 1356378.0,
    },
    {
      date: "23-01-2024",
      cumulative_pnl: 1349881.0,
    },
    {
      date: "24-01-2024",
      cumulative_pnl: 1373707.0,
    },
    {
      date: "25-01-2024",
      cumulative_pnl: 1338730.0,
    },
    {
      date: "29-01-2024",
      cumulative_pnl: 1331066.0,
    },
    {
      date: "30-01-2024",
      cumulative_pnl: 1339677.0,
    },
    {
      date: "31-01-2024",
      cumulative_pnl: 1397624.0,
    },
    {
      date: "01-02-2024",
      cumulative_pnl: 1336824.0,
    },
    {
      date: "02-02-2024",
      cumulative_pnl: 1298033.0,
    },
    {
      date: "05-02-2024",
      cumulative_pnl: 1374044.0,
    },
    {
      date: "06-02-2024",
      cumulative_pnl: 1372331.0,
    },
    {
      date: "07-02-2024",
      cumulative_pnl: 1390146.0,
    },
    {
      date: "08-02-2024",
      cumulative_pnl: 1396598.0,
    },
    {
      date: "09-02-2024",
      cumulative_pnl: 1381281.0,
    },
    {
      date: "12-02-2024",
      cumulative_pnl: 1286413.0,
    },
    {
      date: "13-02-2024",
      cumulative_pnl: 1275326.0,
    },
    {
      date: "14-02-2024",
      cumulative_pnl: 1246837.0,
    },
    {
      date: "15-02-2024",
      cumulative_pnl: 1321800.0,
    },
    {
      date: "16-02-2024",
      cumulative_pnl: 1359347.0,
    },
    {
      date: "19-02-2024",
      cumulative_pnl: 1305792.0,
    },
    {
      date: "20-02-2024",
      cumulative_pnl: 1272300.0,
    },
    {
      date: "21-02-2024",
      cumulative_pnl: 1308469.0,
    },
    {
      date: "22-02-2024",
      cumulative_pnl: 1326143.0,
    },
    {
      date: "23-02-2024",
      cumulative_pnl: 1343787.0,
    },
    {
      date: "26-02-2024",
      cumulative_pnl: 1335578.0,
    },
    {
      date: "27-02-2024",
      cumulative_pnl: 1324429.0,
    },
    {
      date: "28-02-2024",
      cumulative_pnl: 1332582.0,
    },
    {
      date: "29-02-2024",
      cumulative_pnl: 1306894.0,
    },
    {
      date: "01-03-2024",
      cumulative_pnl: 1301271.0,
    },
    {
      date: "04-03-2024",
      cumulative_pnl: 1314369.0,
    },
    {
      date: "05-03-2024",
      cumulative_pnl: 1296171.0,
    },
    {
      date: "06-03-2024",
      cumulative_pnl: 1287389.0,
    },
    {
      date: "07-03-2024",
      cumulative_pnl: 1249161.0,
    },
    {
      date: "11-03-2024",
      cumulative_pnl: 1346159.0,
    },
    {
      date: "12-03-2024",
      cumulative_pnl: 1270129.0,
    },
    {
      date: "15-03-2024",
      cumulative_pnl: 1171621.0,
    },
    {
      date: "18-03-2024",
      cumulative_pnl: 1106624.0,
    },
    {
      date: "19-03-2024",
      cumulative_pnl: 1095013.0,
    },
    {
      date: "20-03-2024",
      cumulative_pnl: 1023650.0,
    },
    {
      date: "21-03-2024",
      cumulative_pnl: 1073706.0,
    },
    {
      date: "22-03-2024",
      cumulative_pnl: 1275395.0,
    },
    {
      date: "27-03-2024",
      cumulative_pnl: 1273091.0,
    },
    {
      date: "28-03-2024",
      cumulative_pnl: 1330288.0,
    },
    {
      date: "02-04-2024",
      cumulative_pnl: 1322719.0,
    },
    {
      date: "03-04-2024",
      cumulative_pnl: 1410351.0,
    },
    {
      date: "04-04-2024",
      cumulative_pnl: 1481144.0,
    },
    {
      date: "05-04-2024",
      cumulative_pnl: 1420862.0,
    },
    {
      date: "08-04-2024",
      cumulative_pnl: 1432773.0,
    },
    {
      date: "09-04-2024",
      cumulative_pnl: 1386922.0,
    },
    {
      date: "10-04-2024",
      cumulative_pnl: 1368708.0,
    },
    {
      date: "12-04-2024",
      cumulative_pnl: 1390761.0,
    },
    {
      date: "15-04-2024",
      cumulative_pnl: 1319140.0,
    },
    {
      date: "16-04-2024",
      cumulative_pnl: 1289880.0,
    },
    {
      date: "18-04-2024",
      cumulative_pnl: 1333884.0,
    },
    {
      date: "19-04-2024",
      cumulative_pnl: 1375092.0,
    },
    {
      date: "22-04-2024",
      cumulative_pnl: 1381764.0,
    },
    {
      date: "23-04-2024",
      cumulative_pnl: 1391764.0,
    },
    {
      date: "24-04-2024",
      cumulative_pnl: 1380181.0,
    },
    {
      date: "25-04-2024",
      cumulative_pnl: 1423436.0,
    },
    {
      date: "26-04-2024",
      cumulative_pnl: 1415944.0,
    },
    {
      date: "29-04-2024",
      cumulative_pnl: 1411202.0,
    },
    {
      date: "30-04-2024",
      cumulative_pnl: 1372069.0,
    },
    {
      date: "02-05-2024",
      cumulative_pnl: 1345159.0,
    },
    {
      date: "03-05-2024",
      cumulative_pnl: 1348187.0,
    },
    {
      date: "06-05-2024",
      cumulative_pnl: 1342665.0,
    },
    {
      date: "07-05-2024",
      cumulative_pnl: 1273768.0,
    },
    {
      date: "08-05-2024",
      cumulative_pnl: 1263213.0,
    },
    {
      date: "09-05-2024",
      cumulative_pnl: 1236597.0,
    },
    {
      date: "10-05-2024",
      cumulative_pnl: 1248800.0,
    },
    {
      date: "13-05-2024",
      cumulative_pnl: 1096287.0,
    },
    {
      date: "14-05-2024",
      cumulative_pnl: 1107288.0,
    },
    {
      date: "15-05-2024",
      cumulative_pnl: 1184023.0,
    },
    {
      date: "16-05-2024",
      cumulative_pnl: 1386805.0,
    },
    {
      date: "17-05-2024",
      cumulative_pnl: 1401845.0,
    },
    {
      date: "18-05-2024",
      cumulative_pnl: 1462550.0,
    },
    {
      date: "21-05-2024",
      cumulative_pnl: 1831704.0,
    },
    {
      date: "22-05-2024",
      cumulative_pnl: 1997690.0,
    },
    {
      date: "23-05-2024",
      cumulative_pnl: 2740454.0,
    },
    {
      date: "24-05-2024",
      cumulative_pnl: 2700207.0,
    },
    {
      date: "27-05-2024",
      cumulative_pnl: 2762424.0,
    },
    {
      date: "28-05-2024",
      cumulative_pnl: 2757303.0,
    },
    {
      date: "29-05-2024",
      cumulative_pnl: 2745111.0,
    },
    {
      date: "30-05-2024",
      cumulative_pnl: 2719474.0,
    },
    {
      date: "31-05-2024",
      cumulative_pnl: 2723291.0,
    },
    {
      date: "03-06-2024",
      cumulative_pnl: 2752075.0,
    },
    {
      date: "04-06-2024",
      cumulative_pnl: 2514189.0,
    },
    {
      date: "05-06-2024",
      cumulative_pnl: 2507664.0,
    },
    {
      date: "06-06-2024",
      cumulative_pnl: 2476096.0,
    },
    {
      date: "07-06-2024",
      cumulative_pnl: 2562230.0,
    },
    {
      date: "10-06-2024",
      cumulative_pnl: 2699123.0,
    },
    {
      date: "11-06-2024",
      cumulative_pnl: 2644595.0,
    },
    {
      date: "12-06-2024",
      cumulative_pnl: 2521874.0,
    },
    {
      date: "13-06-2024",
      cumulative_pnl: 2473154.0,
    },
    {
      date: "14-06-2024",
      cumulative_pnl: 3221776.0,
    },
    {
      date: "18-06-2024",
      cumulative_pnl: 3773201.0,
    },
    {
      date: "19-06-2024",
      cumulative_pnl: 3734720.0,
    },
    {
      date: "20-06-2024",
      cumulative_pnl: 3720600.0,
    },
    {
      date: "21-06-2024",
      cumulative_pnl: 3666812.0,
    },
    {
      date: "22-06-2024",
      cumulative_pnl: 3651682.0,
    },
    {
      date: "24-06-2024",
      cumulative_pnl: 3591653.0,
    },
    {
      date: "25-06-2024",
      cumulative_pnl: 3577266.0,
    },
    {
      date: "26-06-2024",
      cumulative_pnl: 3581474.0,
    },
    {
      date: "27-06-2024",
      cumulative_pnl: 3569727.0,
    },
    {
      date: "28-06-2024",
      cumulative_pnl: 3605107.0,
    },
    {
      date: "01-07-2024",
      cumulative_pnl: 3627401.0,
    },
    {
      date: "02-07-2024",
      cumulative_pnl: 3654839.0,
    },
    {
      date: "03-07-2024",
      cumulative_pnl: 3626430.0,
    },
    {
      date: "04-07-2024",
      cumulative_pnl: 3619014.0,
    },
    {
      date: "05-07-2024",
      cumulative_pnl: 3749484.0,
    },
    {
      date: "08-07-2024",
      cumulative_pnl: 3815427.0,
    },
    {
      date: "09-07-2024",
      cumulative_pnl: 3797537.0,
    },
    {
      date: "10-07-2024",
      cumulative_pnl: 3755344.0,
    },
    {
      date: "11-07-2024",
      cumulative_pnl: 3721000.0,
    },
    {
      date: "12-07-2024",
      cumulative_pnl: 3713522.0,
    },
    {
      date: "15-07-2024",
      cumulative_pnl: 3649880.0,
    },
    {
      date: "16-07-2024",
      cumulative_pnl: 3714277.0,
    },
    {
      date: "18-07-2024",
      cumulative_pnl: 3681848.0,
    },
    {
      date: "19-07-2024",
      cumulative_pnl: 3601904.0,
    },
    {
      date: "22-07-2024",
      cumulative_pnl: 3653621.0,
    },
    {
      date: "23-07-2024",
      cumulative_pnl: 3593852.0,
    },
    {
      date: "24-07-2024",
      cumulative_pnl: 3446602.0,
    },
    {
      date: "25-07-2024",
      cumulative_pnl: 3411386.0,
    },
    {
      date: "26-07-2024",
      cumulative_pnl: 3379950.0,
    },
    {
      date: "29-07-2024",
      cumulative_pnl: 3452483.0,
    },
    {
      date: "30-07-2024",
      cumulative_pnl: 3505060.0,
    },
    {
      date: "31-07-2024",
      cumulative_pnl: 3495004.0,
    },
    {
      date: "01-08-2024",
      cumulative_pnl: 3457660.0,
    },
    {
      date: "02-08-2024",
      cumulative_pnl: 3285118.0,
    },
    {
      date: "05-08-2024",
      cumulative_pnl: 3399408.0,
    },
    {
      date: "06-08-2024",
      cumulative_pnl: 3321645.0,
    },
    {
      date: "07-08-2024",
      cumulative_pnl: 3304862.0,
    },
    {
      date: "08-08-2024",
      cumulative_pnl: 3129121.0,
    },
    {
      date: "09-08-2024",
      cumulative_pnl: 3106046.0,
    },
    {
      date: "12-08-2024",
      cumulative_pnl: 3156528.8,
    },
    {
      date: "13-08-2024",
      cumulative_pnl: 3068669.55,
    },
    {
      date: "14-08-2024",
      cumulative_pnl: 3020957.55,
    },
    {
      date: "16-08-2024",
      cumulative_pnl: 2975340.05,
    },
    {
      date: "19-08-2024",
      cumulative_pnl: 3050614.05,
    },
    {
      date: "20-08-2024",
      cumulative_pnl: 3139930.3,
    },
    {
      date: "21-08-2024",
      cumulative_pnl: 3396817.8,
    },
    {
      date: "22-08-2024",
      cumulative_pnl: 3310033.65,
    },
    {
      date: "23-08-2024",
      cumulative_pnl: 4218063.65,
    },
    {
      date: "26-08-2024",
      cumulative_pnl: 4206242.4,
    },
    {
      date: "27-08-2024",
      cumulative_pnl: 4148214.6,
    },
    {
      date: "28-08-2024",
      cumulative_pnl: 4256151.050000001,
    },
    {
      date: "29-08-2024",
      cumulative_pnl: 4233391.050000001,
    },
    {
      date: "30-08-2024",
      cumulative_pnl: 4286770.800000001,
    },
    {
      date: "02-09-2024",
      cumulative_pnl: 4244261.800000001,
    },
    {
      date: "03-09-2024",
      cumulative_pnl: 4150455.3000000003,
    },
    {
      date: "04-09-2024",
      cumulative_pnl: 4093167.8000000003,
    },
    {
      date: "05-09-2024",
      cumulative_pnl: 4077025.4000000004,
    },
    {
      date: "06-09-2024",
      cumulative_pnl: 3992069.1500000004,
    },
    {
      date: "09-09-2024",
      cumulative_pnl: 3957557.4000000004,
    },
    {
      date: "10-09-2024",
      cumulative_pnl: 3888816.1500000004,
    },
    {
      date: "11-09-2024",
      cumulative_pnl: 4029593.0000000005,
    },
    {
      date: "12-09-2024",
      cumulative_pnl: 4019823.7500000005,
    },
    {
      date: "13-09-2024",
      cumulative_pnl: 4213055.5,
    },
    {
      date: "16-09-2024",
      cumulative_pnl: 4593450.800000001,
    },
    {
      date: "17-09-2024",
      cumulative_pnl: 4460102.15,
    },
    {
      date: "18-09-2024",
      cumulative_pnl: 4417521.9,
    },
    {
      date: "19-09-2024",
      cumulative_pnl: 4307729.65,
    },
    {
      date: "20-09-2024",
      cumulative_pnl: 4606255.2,
    },
    {
      date: "23-09-2024",
      cumulative_pnl: 4628938.95,
    },
    {
      date: "24-09-2024",
      cumulative_pnl: 4606939.65,
    },
    {
      date: "25-09-2024",
      cumulative_pnl: 4717359.65,
    },
    {
      date: "26-09-2024",
      cumulative_pnl: 4663709.100000001,
    },
    {
      date: "27-09-2024",
      cumulative_pnl: 4628842.850000001,
    },
    {
      date: "30-09-2024",
      cumulative_pnl: 4500023.0,
    },
  ],

  month_wise_pnl_data: [
    {
      bank: 0.0,
      date: "Aug-23",
      nifty: -393.0,
      stock: -17143.0,
      total_pnl: -17536.0,
    },
    {
      bank: -2355.0,
      date: "Sep-23",
      nifty: 54203.0,
      stock: 0.0,
      total_pnl: 51848.0,
    },
    {
      bank: 21598.0,
      date: "Oct-23",
      nifty: 74258.0,
      stock: 0.0,
      total_pnl: 95856.0,
    },
    {
      bank: 6263.0,
      date: "Nov-23",
      nifty: 32244.0,
      stock: 0.0,
      total_pnl: 38507.0,
    },
    {
      bank: 59106.0,
      date: "Dec-23",
      nifty: 119714.0,
      stock: -2090.0,
      total_pnl: 176730.0,
    },
    {
      bank: -23916.0,
      date: "Jan-24",
      nifty: -3673.0,
      stock: 79808.0,
      total_pnl: 52219.0,
    },
    {
      bank: -124717.0,
      date: "Feb-24",
      nifty: -50549.0,
      stock: 84536.0,
      total_pnl: -90730.0,
    },
    {
      bank: -137697.0,
      date: "Mar-24",
      nifty: -34975.0,
      stock: 196066.0,
      total_pnl: 23394.0,
    },
    {
      bank: -375.0,
      date: "Apr-24",
      nifty: 64897.0,
      stock: -22741.0,
      total_pnl: 41781.0,
    },
    {
      bank: 75836.0,
      date: "May-24",
      nifty: 312277.0,
      stock: 963109.0,
      total_pnl: 1351222.0,
    },
    {
      bank: 61465.0,
      date: "Jun-24",
      nifty: -47097.0,
      stock: 867448.0,
      total_pnl: 881816.0,
    },
    {
      bank: 0.0,
      date: "Jul-24",
      nifty: -41858.0,
      stock: -68245.0,
      total_pnl: -110103.0,
    },
    {
      bank: -14398.75,
      date: "Aug-24",
      nifty: 85448.75,
      stock: 720716.8,
      total_pnl: 791766.8,
    },
    {
      bank: -4672.5,
      date: "Sep-24",
      nifty: 200073.75,
      stock: 17850.950000000004,
      total_pnl: 213252.2,
    },
  ],

  strategy_wise_trade_metrics: [
    {
      asset: "all",
      strategy_wise_metrics: [
        {
          strategy: "Blank",
          totalPNL: 750595.0,
          totalTrades: 961,
          positiveTrades: 235,
          negativeTrades: 726,
          accuracy: 24.45,
          winTradesRS: 2938594.0,
          winTradePercentage: 24.45,
          lossTradesRS: -2187999.0,
          lossTradePercentage: 75.55,
          rrRatio: 4.15,
          avgProfitPerWinTrades: 12504.655319148937,
          totalProfitOnWinDays: 2938594.0,
          maxProfitOnWinDay: 87750.0,
          avgLossPerLossTrades: -3013.7727272727275,
          totalLossOnLossDays: -2187999.0,
          maxLossOnLossDay: -26180.0,
          maxWinningStreakDays: 13,
          maxLosingStreakDays: 51,
          winRatio: 0.24,
          lossRatio: 0.76,
          totalWinDays: 235,
          totalLossDays: 726,
          expectancy: 781.06,
        },
        {
          strategy: "CRB_",
          totalPNL: -3118.0,
          totalTrades: 66,
          positiveTrades: 31,
          negativeTrades: 35,
          accuracy: 46.97,
          winTradesRS: 11038.0,
          winTradePercentage: 46.97,
          lossTradesRS: -14156.0,
          lossTradePercentage: 53.03,
          rrRatio: 0.88,
          avgProfitPerWinTrades: 356.06451612903226,
          totalProfitOnWinDays: 11038.0,
          maxProfitOnWinDay: 1650.0,
          avgLossPerLossTrades: -404.45714285714286,
          totalLossOnLossDays: -14156.0,
          maxLossOnLossDay: -1325.0,
          maxWinningStreakDays: 6,
          maxLosingStreakDays: 9,
          winRatio: 0.47,
          lossRatio: 0.53,
          totalWinDays: 31,
          totalLossDays: 35,
          expectancy: -47.24,
        },
        {
          strategy: "FDT_",
          totalPNL: 117845.0,
          totalTrades: 65,
          positiveTrades: 24,
          negativeTrades: 41,
          accuracy: 36.92,
          winTradesRS: 277888.0,
          winTradePercentage: 36.92,
          lossTradesRS: -160043.0,
          lossTradePercentage: 63.08,
          rrRatio: 2.97,
          avgProfitPerWinTrades: 11578.666666666666,
          totalProfitOnWinDays: 277888.0,
          maxProfitOnWinDay: 42820.0,
          avgLossPerLossTrades: -3903.487804878049,
          totalLossOnLossDays: -160043.0,
          maxLossOnLossDay: -46000.0,
          maxWinningStreakDays: 5,
          maxLosingStreakDays: 8,
          winRatio: 0.37,
          lossRatio: 0.63,
          totalWinDays: 24,
          totalLossDays: 41,
          expectancy: 1813.0,
        },
        {
          strategy: "FDT_Daily",
          totalPNL: -61847.0,
          totalTrades: 4,
          positiveTrades: 2,
          negativeTrades: 2,
          accuracy: 50.0,
          winTradesRS: 3473.0,
          winTradePercentage: 50.0,
          lossTradesRS: -65320.0,
          lossTradePercentage: 50.0,
          rrRatio: 0.05,
          avgProfitPerWinTrades: 1736.5,
          totalProfitOnWinDays: 3473.0,
          maxProfitOnWinDay: 3000.0,
          avgLossPerLossTrades: -32660.0,
          totalLossOnLossDays: -65320.0,
          maxLossOnLossDay: -49320.0,
          maxWinningStreakDays: 2,
          maxLosingStreakDays: 2,
          winRatio: 0.5,
          lossRatio: 0.5,
          totalWinDays: 2,
          totalLossDays: 2,
          expectancy: -15461.75,
        },
        {
          strategy: "Gamma",
          totalPNL: -11432.0,
          totalTrades: 4,
          positiveTrades: 1,
          negativeTrades: 3,
          accuracy: 25.0,
          winTradesRS: 1830.0,
          winTradePercentage: 25.0,
          lossTradesRS: -13262.0,
          lossTradePercentage: 75.0,
          rrRatio: 0.41,
          avgProfitPerWinTrades: 1830.0,
          totalProfitOnWinDays: 1830.0,
          maxProfitOnWinDay: 1830.0,
          avgLossPerLossTrades: -4420.666666666667,
          totalLossOnLossDays: -13262.0,
          maxLossOnLossDay: -11364.0,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 2,
          winRatio: 0.25,
          lossRatio: 0.75,
          totalWinDays: 1,
          totalLossDays: 3,
          expectancy: -2858.0,
        },
        {
          strategy: "HE_PC2",
          totalPNL: 360460.39999999997,
          totalTrades: 953,
          positiveTrades: 286,
          negativeTrades: 667,
          accuracy: 30.01,
          winTradesRS: 4296322.85,
          winTradePercentage: 30.01,
          lossTradesRS: -3935862.45,
          lossTradePercentage: 69.99,
          rrRatio: 2.55,
          avgProfitPerWinTrades: 15022.107867132865,
          totalProfitOnWinDays: 4296322.85,
          maxProfitOnWinDay: 324415.0,
          avgLossPerLossTrades: -5900.843253373314,
          totalLossOnLossDays: -3935862.45,
          maxLossOnLossDay: -32868.0,
          maxWinningStreakDays: 8,
          maxLosingStreakDays: 26,
          winRatio: 0.3,
          lossRatio: 0.7,
          totalWinDays: 286,
          totalLossDays: 667,
          expectancy: 378.24,
        },
        {
          strategy: "HE_PC2_MA10",
          totalPNL: 82580.5,
          totalTrades: 15,
          positiveTrades: 7,
          negativeTrades: 8,
          accuracy: 46.67,
          winTradesRS: 114709.0,
          winTradePercentage: 46.67,
          lossTradesRS: -32128.5,
          lossTradePercentage: 53.33,
          rrRatio: 4.08,
          avgProfitPerWinTrades: 16387.0,
          totalProfitOnWinDays: 114709.0,
          maxProfitOnWinDay: 65820.0,
          avgLossPerLossTrades: -4016.0625,
          totalLossOnLossDays: -32128.5,
          maxLossOnLossDay: -9140.0,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 3,
          winRatio: 0.47,
          lossRatio: 0.53,
          totalWinDays: 7,
          totalLossDays: 8,
          expectancy: 5505.37,
        },
        {
          strategy: "HE_PC5",
          totalPNL: -591.0,
          totalTrades: 28,
          positiveTrades: 6,
          negativeTrades: 22,
          accuracy: 21.43,
          winTradesRS: 88743.75,
          winTradePercentage: 21.43,
          lossTradesRS: -89334.75,
          lossTradePercentage: 78.57,
          rrRatio: 3.64,
          avgProfitPerWinTrades: 14790.625,
          totalProfitOnWinDays: 88743.75,
          maxProfitOnWinDay: 62403.75,
          avgLossPerLossTrades: -4060.6704545454545,
          totalLossOnLossDays: -89334.75,
          maxLossOnLossDay: -14947.5,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 9,
          winRatio: 0.21,
          lossRatio: 0.79,
          totalWinDays: 6,
          totalLossDays: 22,
          expectancy: -21.11,
        },
        {
          strategy: "HHPC_LLPC",
          totalPNL: -7876.0,
          totalTrades: 2,
          positiveTrades: 0,
          negativeTrades: 2,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -7876.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -3938.0,
          totalLossOnLossDays: -7876.0,
          maxLossOnLossDay: -5301.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 2,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 2,
          expectancy: -3938.0,
        },
        {
          strategy: "HHPC_PC2",
          totalPNL: 89559.5,
          totalTrades: 202,
          positiveTrades: 75,
          negativeTrades: 127,
          accuracy: 37.13,
          winTradesRS: 715862.1,
          winTradePercentage: 37.13,
          lossTradesRS: -626302.6,
          lossTradePercentage: 62.87,
          rrRatio: 1.94,
          avgProfitPerWinTrades: 9544.828,
          totalProfitOnWinDays: 715862.1,
          maxProfitOnWinDay: 43218.75,
          avgLossPerLossTrades: -4931.516535433071,
          totalLossOnLossDays: -626302.6,
          maxLossOnLossDay: -19785.0,
          maxWinningStreakDays: 6,
          maxLosingStreakDays: 10,
          winRatio: 0.37,
          lossRatio: 0.63,
          totalWinDays: 75,
          totalLossDays: 127,
          expectancy: 443.36,
        },
        {
          strategy: "HHPC_PC2_MA10",
          totalPNL: 92705.0,
          totalTrades: 1,
          positiveTrades: 1,
          negativeTrades: 0,
          accuracy: 100.0,
          winTradesRS: 92705.0,
          winTradePercentage: 100.0,
          lossTradesRS: 0.0,
          lossTradePercentage: 0.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 92705.0,
          totalProfitOnWinDays: 92705.0,
          maxProfitOnWinDay: 92705.0,
          avgLossPerLossTrades: 0.0,
          totalLossOnLossDays: 0.0,
          maxLossOnLossDay: 0.0,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 0,
          winRatio: 1.0,
          lossRatio: 0.0,
          totalWinDays: 1,
          totalLossDays: 0,
          expectancy: 92705.0,
        },
        {
          strategy: "HHPC_PC5",
          totalPNL: -38557.0,
          totalTrades: 50,
          positiveTrades: 17,
          negativeTrades: 33,
          accuracy: 34.0,
          winTradesRS: 177312.0,
          winTradePercentage: 34.0,
          lossTradesRS: -215869.0,
          lossTradePercentage: 66.0,
          rrRatio: 1.59,
          avgProfitPerWinTrades: 10430.117647058823,
          totalProfitOnWinDays: 177312.0,
          maxProfitOnWinDay: 39270.0,
          avgLossPerLossTrades: -6541.484848484848,
          totalLossOnLossDays: -215869.0,
          maxLossOnLossDay: -32730.0,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 11,
          winRatio: 0.34,
          lossRatio: 0.66,
          totalWinDays: 17,
          totalLossDays: 33,
          expectancy: -771.14,
        },
        {
          strategy: "HHPC_PC5_MA10",
          totalPNL: -24557.75,
          totalTrades: 6,
          positiveTrades: 1,
          negativeTrades: 5,
          accuracy: 16.67,
          winTradesRS: 19910.0,
          winTradePercentage: 16.67,
          lossTradesRS: -44467.75,
          lossTradePercentage: 83.33,
          rrRatio: 2.24,
          avgProfitPerWinTrades: 19910.0,
          totalProfitOnWinDays: 19910.0,
          maxProfitOnWinDay: 19910.0,
          avgLossPerLossTrades: -8893.55,
          totalLossOnLossDays: -44467.75,
          maxLossOnLossDay: -18596.25,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 3,
          winRatio: 0.17,
          lossRatio: 0.83,
          totalWinDays: 1,
          totalLossDays: 5,
          expectancy: -4092.96,
        },
        {
          strategy: "HHPC_weekly",
          totalPNL: -6735.0,
          totalTrades: 5,
          positiveTrades: 0,
          negativeTrades: 5,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -6735.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -1347.0,
          totalLossOnLossDays: -6735.0,
          maxLossOnLossDay: -2768.75,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 5,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 5,
          expectancy: -1347.0,
        },
        {
          strategy: "Heavy_Entry_Very_Far_OTM",
          totalPNL: 7088.0,
          totalTrades: 3,
          positiveTrades: 3,
          negativeTrades: 0,
          accuracy: 100.0,
          winTradesRS: 7088.0,
          winTradePercentage: 100.0,
          lossTradesRS: 0.0,
          lossTradePercentage: 0.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 2362.6666666666665,
          totalProfitOnWinDays: 7088.0,
          maxProfitOnWinDay: 2565.0,
          avgLossPerLossTrades: 0.0,
          totalLossOnLossDays: 0.0,
          maxLossOnLossDay: 0.0,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 0,
          winRatio: 1.0,
          lossRatio: 0.0,
          totalWinDays: 3,
          totalLossDays: 0,
          expectancy: 2362.67,
        },
        {
          strategy: "Manual",
          totalPNL: -750.0,
          totalTrades: 1,
          positiveTrades: 0,
          negativeTrades: 1,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -750.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -750.0,
          totalLossOnLossDays: -750.0,
          maxLossOnLossDay: -750.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 1,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 1,
          expectancy: -750.0,
        },
        {
          strategy: "ORB2",
          totalPNL: 8307.0,
          totalTrades: 63,
          positiveTrades: 24,
          negativeTrades: 39,
          accuracy: 38.1,
          winTradesRS: 33799.0,
          winTradePercentage: 38.1,
          lossTradesRS: -25492.0,
          lossTradePercentage: 61.9,
          rrRatio: 2.15,
          avgProfitPerWinTrades: 1408.2916666666667,
          totalProfitOnWinDays: 33799.0,
          maxProfitOnWinDay: 6290.0,
          avgLossPerLossTrades: -653.6410256410256,
          totalLossOnLossDays: -25492.0,
          maxLossOnLossDay: -1690.0,
          maxWinningStreakDays: 5,
          maxLosingStreakDays: 9,
          winRatio: 0.38,
          lossRatio: 0.62,
          totalWinDays: 24,
          totalLossDays: 39,
          expectancy: 131.86,
        },
        {
          strategy: "ORB_1",
          totalPNL: 274950.25,
          totalTrades: 183,
          positiveTrades: 68,
          negativeTrades: 115,
          accuracy: 37.16,
          winTradesRS: 809587.0,
          winTradePercentage: 37.16,
          lossTradesRS: -534636.75,
          lossTradePercentage: 62.84,
          rrRatio: 2.56,
          avgProfitPerWinTrades: 11905.691176470587,
          totalProfitOnWinDays: 809587.0,
          maxProfitOnWinDay: 125438.0,
          avgLossPerLossTrades: -4649.015217391305,
          totalLossOnLossDays: -534636.75,
          maxLossOnLossDay: -28785.0,
          maxWinningStreakDays: 5,
          maxLosingStreakDays: 11,
          winRatio: 0.37,
          lossRatio: 0.63,
          totalWinDays: 68,
          totalLossDays: 115,
          expectancy: 1502.46,
        },
        {
          strategy: "PDI_MA_Daily",
          totalPNL: -17346.0,
          totalTrades: 3,
          positiveTrades: 0,
          negativeTrades: 3,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -17346.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -5782.0,
          totalLossOnLossDays: -17346.0,
          maxLossOnLossDay: -8870.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 3,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 3,
          expectancy: -5782.0,
        },
        {
          strategy: "PDI_MA_LLPC",
          totalPNL: -40347.0,
          totalTrades: 19,
          positiveTrades: 5,
          negativeTrades: 14,
          accuracy: 26.32,
          winTradesRS: 36027.0,
          winTradePercentage: 26.32,
          lossTradesRS: -76374.0,
          lossTradePercentage: 73.68,
          rrRatio: 1.32,
          avgProfitPerWinTrades: 7205.4,
          totalProfitOnWinDays: 36027.0,
          maxProfitOnWinDay: 14585.0,
          avgLossPerLossTrades: -5455.285714285715,
          totalLossOnLossDays: -76374.0,
          maxLossOnLossDay: -11241.0,
          maxWinningStreakDays: 2,
          maxLosingStreakDays: 9,
          winRatio: 0.26,
          lossRatio: 0.74,
          totalWinDays: 5,
          totalLossDays: 14,
          expectancy: -2123.53,
        },
        {
          strategy: "PDI_MA_PC2",
          totalPNL: 1183687.6,
          totalTrades: 1058,
          positiveTrades: 391,
          negativeTrades: 667,
          accuracy: 36.96,
          winTradesRS: 4158757.15,
          winTradePercentage: 36.96,
          lossTradesRS: -2975069.55,
          lossTradePercentage: 63.04,
          rrRatio: 2.38,
          avgProfitPerWinTrades: 10636.207544757033,
          totalProfitOnWinDays: 4158757.15,
          maxProfitOnWinDay: 111037.5,
          avgLossPerLossTrades: -4460.374137931034,
          totalLossOnLossDays: -2975069.55,
          maxLossOnLossDay: -21450.0,
          maxWinningStreakDays: 15,
          maxLosingStreakDays: 19,
          winRatio: 0.37,
          lossRatio: 0.63,
          totalWinDays: 391,
          totalLossDays: 667,
          expectancy: 1118.8,
        },
        {
          strategy: "PDI_MA_PC2_MA10",
          totalPNL: 28086.25,
          totalTrades: 4,
          positiveTrades: 2,
          negativeTrades: 2,
          accuracy: 50.0,
          winTradesRS: 31941.25,
          winTradePercentage: 50.0,
          lossTradesRS: -3855.0,
          lossTradePercentage: 50.0,
          rrRatio: 8.29,
          avgProfitPerWinTrades: 15970.625,
          totalProfitOnWinDays: 31941.25,
          maxProfitOnWinDay: 24356.25,
          avgLossPerLossTrades: -1927.5,
          totalLossOnLossDays: -3855.0,
          maxLossOnLossDay: -2460.0,
          maxWinningStreakDays: 2,
          maxLosingStreakDays: 1,
          winRatio: 0.5,
          lossRatio: 0.5,
          totalWinDays: 2,
          totalLossDays: 2,
          expectancy: 7021.56,
        },
        {
          strategy: "PDI_MA_PC5",
          totalPNL: 105991.0,
          totalTrades: 40,
          positiveTrades: 13,
          negativeTrades: 27,
          accuracy: 32.5,
          winTradesRS: 213210.75,
          winTradePercentage: 32.5,
          lossTradesRS: -107219.75,
          lossTradePercentage: 67.5,
          rrRatio: 4.13,
          avgProfitPerWinTrades: 16400.826923076922,
          totalProfitOnWinDays: 213210.75,
          maxProfitOnWinDay: 83025.0,
          avgLossPerLossTrades: -3971.1018518518517,
          totalLossOnLossDays: -107219.75,
          maxLossOnLossDay: -8522.5,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 6,
          winRatio: 0.33,
          lossRatio: 0.68,
          totalWinDays: 13,
          totalLossDays: 27,
          expectancy: 2649.78,
        },
        {
          strategy: "PDI_MA_PC5_MA10",
          totalPNL: -1882.5,
          totalTrades: 1,
          positiveTrades: 0,
          negativeTrades: 1,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -1882.5,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -1882.5,
          totalLossOnLossDays: -1882.5,
          maxLossOnLossDay: -1882.5,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 1,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 1,
          expectancy: -1882.5,
        },
        {
          strategy: "PDI_MDI_LLPC",
          totalPNL: -10116.0,
          totalTrades: 3,
          positiveTrades: 1,
          negativeTrades: 2,
          accuracy: 33.33,
          winTradesRS: 4716.0,
          winTradePercentage: 33.33,
          lossTradesRS: -14832.0,
          lossTradePercentage: 66.67,
          rrRatio: 0.64,
          avgProfitPerWinTrades: 4716.0,
          totalProfitOnWinDays: 4716.0,
          maxProfitOnWinDay: 4716.0,
          avgLossPerLossTrades: -7416.0,
          totalLossOnLossDays: -14832.0,
          maxLossOnLossDay: -9732.0,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 2,
          winRatio: 0.33,
          lossRatio: 0.67,
          totalWinDays: 1,
          totalLossDays: 2,
          expectancy: -3372.0,
        },
        {
          strategy: "PDI_MDI_PC2",
          totalPNL: 417874.75,
          totalTrades: 312,
          positiveTrades: 117,
          negativeTrades: 195,
          accuracy: 37.5,
          winTradesRS: 1387808.95,
          winTradePercentage: 37.5,
          lossTradesRS: -969934.2,
          lossTradePercentage: 62.5,
          rrRatio: 2.38,
          avgProfitPerWinTrades: 11861.614957264957,
          totalProfitOnWinDays: 1387808.95,
          maxProfitOnWinDay: 111960.0,
          avgLossPerLossTrades: -4974.0215384615385,
          totalLossOnLossDays: -969934.2,
          maxLossOnLossDay: -18950.0,
          maxWinningStreakDays: 5,
          maxLosingStreakDays: 9,
          winRatio: 0.38,
          lossRatio: 0.62,
          totalWinDays: 117,
          totalLossDays: 195,
          expectancy: 1339.34,
        },
        {
          strategy: "PDI_MDI_PC2_MA10",
          totalPNL: 15062.5,
          totalTrades: 1,
          positiveTrades: 1,
          negativeTrades: 0,
          accuracy: 100.0,
          winTradesRS: 15062.5,
          winTradePercentage: 100.0,
          lossTradesRS: 0.0,
          lossTradePercentage: 0.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 15062.5,
          totalProfitOnWinDays: 15062.5,
          maxProfitOnWinDay: 15062.5,
          avgLossPerLossTrades: 0.0,
          totalLossOnLossDays: 0.0,
          maxLossOnLossDay: 0.0,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 0,
          winRatio: 1.0,
          lossRatio: 0.0,
          totalWinDays: 1,
          totalLossDays: 0,
          expectancy: 15062.5,
        },
        {
          strategy: "PDI_MDI_PC5",
          totalPNL: 46704.5,
          totalTrades: 15,
          positiveTrades: 5,
          negativeTrades: 10,
          accuracy: 33.33,
          winTradesRS: 136140.0,
          winTradePercentage: 33.33,
          lossTradesRS: -89435.5,
          lossTradePercentage: 66.67,
          rrRatio: 3.04,
          avgProfitPerWinTrades: 27228.0,
          totalProfitOnWinDays: 136140.0,
          maxProfitOnWinDay: 83025.0,
          avgLossPerLossTrades: -8943.55,
          totalLossOnLossDays: -89435.5,
          maxLossOnLossDay: -18861.25,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 5,
          winRatio: 0.33,
          lossRatio: 0.67,
          totalWinDays: 5,
          totalLossDays: 10,
          expectancy: 3113.63,
        },
        {
          strategy: "Wrong_trade",
          totalPNL: -1627.0,
          totalTrades: 3,
          positiveTrades: 0,
          negativeTrades: 3,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -1627.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -542.3333333333334,
          totalLossOnLossDays: -1627.0,
          maxLossOnLossDay: -1345.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 3,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 3,
          expectancy: -542.33,
        },
        {
          strategy: "_FDT_Very_far_OTM",
          totalPNL: 5061.0,
          totalTrades: 21,
          positiveTrades: 6,
          negativeTrades: 15,
          accuracy: 28.57,
          winTradesRS: 14830.0,
          winTradePercentage: 28.57,
          lossTradesRS: -9769.0,
          lossTradePercentage: 71.43,
          rrRatio: 3.8,
          avgProfitPerWinTrades: 2471.6666666666665,
          totalProfitOnWinDays: 14830.0,
          maxProfitOnWinDay: 5130.0,
          avgLossPerLossTrades: -651.2666666666667,
          totalLossOnLossDays: -9769.0,
          maxLossOnLossDay: -4740.0,
          maxWinningStreakDays: 4,
          maxLosingStreakDays: 9,
          winRatio: 0.29,
          lossRatio: 0.71,
          totalWinDays: 6,
          totalLossDays: 15,
          expectancy: 241.0,
        },
        {
          strategy: "unknown",
          totalPNL: -4126.0,
          totalTrades: 7,
          positiveTrades: 1,
          negativeTrades: 6,
          accuracy: 14.29,
          winTradesRS: 1020.0,
          winTradePercentage: 14.29,
          lossTradesRS: -5146.0,
          lossTradePercentage: 85.71,
          rrRatio: 1.19,
          avgProfitPerWinTrades: 1020.0,
          totalProfitOnWinDays: 1020.0,
          maxProfitOnWinDay: 1020.0,
          avgLossPerLossTrades: -857.6666666666666,
          totalLossOnLossDays: -5146.0,
          maxLossOnLossDay: -2228.0,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 5,
          winRatio: 0.14,
          lossRatio: 0.86,
          totalWinDays: 1,
          totalLossDays: 6,
          expectancy: -589.43,
        },
      ],
    },
    {
      asset: "Nifty",
      strategy_wise_metrics: [
        {
          strategy: "Blank",
          totalPNL: -49330.0,
          totalTrades: 23,
          positiveTrades: 8,
          negativeTrades: 15,
          accuracy: 34.78,
          winTradesRS: 77118.0,
          winTradePercentage: 34.78,
          lossTradesRS: -126448.0,
          lossTradePercentage: 65.22,
          rrRatio: 1.14,
          avgProfitPerWinTrades: 9639.75,
          totalProfitOnWinDays: 77118.0,
          maxProfitOnWinDay: 24840.0,
          avgLossPerLossTrades: -8429.866666666667,
          totalLossOnLossDays: -126448.0,
          maxLossOnLossDay: -17545.0,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 4,
          winRatio: 0.35,
          lossRatio: 0.65,
          totalWinDays: 8,
          totalLossDays: 15,
          expectancy: -2144.78,
        },
        {
          strategy: "CRB_",
          totalPNL: 1518.0,
          totalTrades: 29,
          positiveTrades: 15,
          negativeTrades: 14,
          accuracy: 51.72,
          winTradesRS: 7296.0,
          winTradePercentage: 51.72,
          lossTradesRS: -5778.0,
          lossTradePercentage: 48.28,
          rrRatio: 1.18,
          avgProfitPerWinTrades: 486.4,
          totalProfitOnWinDays: 7296.0,
          maxProfitOnWinDay: 1650.0,
          avgLossPerLossTrades: -412.7142857142857,
          totalLossOnLossDays: -5778.0,
          maxLossOnLossDay: -1325.0,
          maxWinningStreakDays: 4,
          maxLosingStreakDays: 3,
          winRatio: 0.52,
          lossRatio: 0.48,
          totalWinDays: 15,
          totalLossDays: 14,
          expectancy: 52.34,
        },
        {
          strategy: "FDT_",
          totalPNL: 96746.0,
          totalTrades: 47,
          positiveTrades: 15,
          negativeTrades: 32,
          accuracy: 31.91,
          winTradesRS: 237346.0,
          winTradePercentage: 31.91,
          lossTradesRS: -140600.0,
          lossTradePercentage: 68.09,
          rrRatio: 3.6,
          avgProfitPerWinTrades: 15823.066666666668,
          totalProfitOnWinDays: 237346.0,
          maxProfitOnWinDay: 42820.0,
          avgLossPerLossTrades: -4393.75,
          totalLossOnLossDays: -140600.0,
          maxLossOnLossDay: -46000.0,
          maxWinningStreakDays: 4,
          maxLosingStreakDays: 10,
          winRatio: 0.32,
          lossRatio: 0.68,
          totalWinDays: 15,
          totalLossDays: 32,
          expectancy: 2058.43,
        },
        {
          strategy: "FDT_Daily",
          totalPNL: -61847.0,
          totalTrades: 4,
          positiveTrades: 2,
          negativeTrades: 2,
          accuracy: 50.0,
          winTradesRS: 3473.0,
          winTradePercentage: 50.0,
          lossTradesRS: -65320.0,
          lossTradePercentage: 50.0,
          rrRatio: 0.05,
          avgProfitPerWinTrades: 1736.5,
          totalProfitOnWinDays: 3473.0,
          maxProfitOnWinDay: 3000.0,
          avgLossPerLossTrades: -32660.0,
          totalLossOnLossDays: -65320.0,
          maxLossOnLossDay: -49320.0,
          maxWinningStreakDays: 2,
          maxLosingStreakDays: 2,
          winRatio: 0.5,
          lossRatio: 0.5,
          totalWinDays: 2,
          totalLossDays: 2,
          expectancy: -15461.75,
        },
        {
          strategy: "Gamma",
          totalPNL: -11087.0,
          totalTrades: 3,
          positiveTrades: 1,
          negativeTrades: 2,
          accuracy: 33.33,
          winTradesRS: 1830.0,
          winTradePercentage: 33.33,
          lossTradesRS: -12917.0,
          lossTradePercentage: 66.67,
          rrRatio: 0.28,
          avgProfitPerWinTrades: 1830.0,
          totalProfitOnWinDays: 1830.0,
          maxProfitOnWinDay: 1830.0,
          avgLossPerLossTrades: -6458.5,
          totalLossOnLossDays: -12917.0,
          maxLossOnLossDay: -11364.0,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 2,
          winRatio: 0.33,
          lossRatio: 0.67,
          totalWinDays: 1,
          totalLossDays: 2,
          expectancy: -3695.67,
        },
        {
          strategy: "HE_PC2",
          totalPNL: 116469.75,
          totalTrades: 53,
          positiveTrades: 23,
          negativeTrades: 30,
          accuracy: 43.4,
          winTradesRS: 162275.25,
          winTradePercentage: 43.4,
          lossTradesRS: -45805.5,
          lossTradePercentage: 56.6,
          rrRatio: 4.62,
          avgProfitPerWinTrades: 7055.445652173913,
          totalProfitOnWinDays: 162275.25,
          maxProfitOnWinDay: 39171.0,
          avgLossPerLossTrades: -1526.85,
          totalLossOnLossDays: -45805.5,
          maxLossOnLossDay: -6250.0,
          maxWinningStreakDays: 10,
          maxLosingStreakDays: 8,
          winRatio: 0.43,
          lossRatio: 0.57,
          totalWinDays: 23,
          totalLossDays: 30,
          expectancy: 2197.54,
        },
        {
          strategy: "HE_PC2_MA10",
          totalPNL: 79475.5,
          totalTrades: 12,
          positiveTrades: 6,
          negativeTrades: 6,
          accuracy: 50.0,
          winTradesRS: 93589.0,
          winTradePercentage: 50.0,
          lossTradesRS: -14113.5,
          lossTradePercentage: 50.0,
          rrRatio: 6.63,
          avgProfitPerWinTrades: 15598.166666666666,
          totalProfitOnWinDays: 93589.0,
          maxProfitOnWinDay: 65820.0,
          avgLossPerLossTrades: -2352.25,
          totalLossOnLossDays: -14113.5,
          maxLossOnLossDay: -5355.0,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 2,
          winRatio: 0.5,
          lossRatio: 0.5,
          totalWinDays: 6,
          totalLossDays: 6,
          expectancy: 6622.96,
        },
        {
          strategy: "HE_PC5",
          totalPNL: -5735.75,
          totalTrades: 19,
          positiveTrades: 3,
          negativeTrades: 16,
          accuracy: 15.79,
          winTradesRS: 64533.75,
          winTradePercentage: 15.79,
          lossTradesRS: -70269.5,
          lossTradePercentage: 84.21,
          rrRatio: 4.9,
          avgProfitPerWinTrades: 21511.25,
          totalProfitOnWinDays: 64533.75,
          maxProfitOnWinDay: 62403.75,
          avgLossPerLossTrades: -4391.84375,
          totalLossOnLossDays: -70269.5,
          maxLossOnLossDay: -14947.5,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 8,
          winRatio: 0.16,
          lossRatio: 0.84,
          totalWinDays: 3,
          totalLossDays: 16,
          expectancy: -301.88,
        },
        {
          strategy: "HHPC_LLPC",
          totalPNL: -2575.0,
          totalTrades: 1,
          positiveTrades: 0,
          negativeTrades: 1,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -2575.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -2575.0,
          totalLossOnLossDays: -2575.0,
          maxLossOnLossDay: -2575.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 1,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 1,
          expectancy: -2575.0,
        },
        {
          strategy: "HHPC_PC2",
          totalPNL: -1323.0,
          totalTrades: 9,
          positiveTrades: 3,
          negativeTrades: 6,
          accuracy: 33.33,
          winTradesRS: 10380.0,
          winTradePercentage: 33.33,
          lossTradesRS: -11703.0,
          lossTradePercentage: 66.67,
          rrRatio: 1.77,
          avgProfitPerWinTrades: 3460.0,
          totalProfitOnWinDays: 10380.0,
          maxProfitOnWinDay: 9390.0,
          avgLossPerLossTrades: -1950.5,
          totalLossOnLossDays: -11703.0,
          maxLossOnLossDay: -5095.0,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 3,
          winRatio: 0.33,
          lossRatio: 0.67,
          totalWinDays: 3,
          totalLossDays: 6,
          expectancy: -147.0,
        },
        {
          strategy: "HHPC_PC2_MA10",
          totalPNL: 92705.0,
          totalTrades: 1,
          positiveTrades: 1,
          negativeTrades: 0,
          accuracy: 100.0,
          winTradesRS: 92705.0,
          winTradePercentage: 100.0,
          lossTradesRS: 0.0,
          lossTradePercentage: 0.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 92705.0,
          totalProfitOnWinDays: 92705.0,
          maxProfitOnWinDay: 92705.0,
          avgLossPerLossTrades: 0.0,
          totalLossOnLossDays: 0.0,
          maxLossOnLossDay: 0.0,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 0,
          winRatio: 1.0,
          lossRatio: 0.0,
          totalWinDays: 1,
          totalLossDays: 0,
          expectancy: 92705.0,
        },
        {
          strategy: "HHPC_PC5",
          totalPNL: -25266.25,
          totalTrades: 7,
          positiveTrades: 2,
          negativeTrades: 5,
          accuracy: 28.57,
          winTradesRS: 24580.0,
          winTradePercentage: 28.57,
          lossTradesRS: -49846.25,
          lossTradePercentage: 71.43,
          rrRatio: 1.23,
          avgProfitPerWinTrades: 12290.0,
          totalProfitOnWinDays: 24580.0,
          maxProfitOnWinDay: 16950.0,
          avgLossPerLossTrades: -9969.25,
          totalLossOnLossDays: -49846.25,
          maxLossOnLossDay: -32730.0,
          maxWinningStreakDays: 2,
          maxLosingStreakDays: 3,
          winRatio: 0.29,
          lossRatio: 0.71,
          totalWinDays: 2,
          totalLossDays: 5,
          expectancy: -3609.46,
        },
        {
          strategy: "HHPC_PC5_MA10",
          totalPNL: -24557.75,
          totalTrades: 6,
          positiveTrades: 1,
          negativeTrades: 5,
          accuracy: 16.67,
          winTradesRS: 19910.0,
          winTradePercentage: 16.67,
          lossTradesRS: -44467.75,
          lossTradePercentage: 83.33,
          rrRatio: 2.24,
          avgProfitPerWinTrades: 19910.0,
          totalProfitOnWinDays: 19910.0,
          maxProfitOnWinDay: 19910.0,
          avgLossPerLossTrades: -8893.55,
          totalLossOnLossDays: -44467.75,
          maxLossOnLossDay: -18596.25,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 3,
          winRatio: 0.17,
          lossRatio: 0.83,
          totalWinDays: 1,
          totalLossDays: 5,
          expectancy: -4092.96,
        },
        {
          strategy: "HHPC_weekly",
          totalPNL: -5917.5,
          totalTrades: 4,
          positiveTrades: 0,
          negativeTrades: 4,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -5917.5,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -1479.375,
          totalLossOnLossDays: -5917.5,
          maxLossOnLossDay: -2768.75,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 4,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 4,
          expectancy: -1479.38,
        },
        {
          strategy: "Heavy_Entry_Very_Far_OTM",
          totalPNL: 7088.0,
          totalTrades: 3,
          positiveTrades: 3,
          negativeTrades: 0,
          accuracy: 100.0,
          winTradesRS: 7088.0,
          winTradePercentage: 100.0,
          lossTradesRS: 0.0,
          lossTradePercentage: 0.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 2362.6666666666665,
          totalProfitOnWinDays: 7088.0,
          maxProfitOnWinDay: 2565.0,
          avgLossPerLossTrades: 0.0,
          totalLossOnLossDays: 0.0,
          maxLossOnLossDay: 0.0,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 0,
          winRatio: 1.0,
          lossRatio: 0.0,
          totalWinDays: 3,
          totalLossDays: 0,
          expectancy: 2362.67,
        },
        {
          strategy: "ORB2",
          totalPNL: 5585.0,
          totalTrades: 31,
          positiveTrades: 12,
          negativeTrades: 19,
          accuracy: 38.71,
          winTradesRS: 20205.0,
          winTradePercentage: 38.71,
          lossTradesRS: -14620.0,
          lossTradePercentage: 61.29,
          rrRatio: 2.19,
          avgProfitPerWinTrades: 1683.75,
          totalProfitOnWinDays: 20205.0,
          maxProfitOnWinDay: 6290.0,
          avgLossPerLossTrades: -769.4736842105264,
          totalLossOnLossDays: -14620.0,
          maxLossOnLossDay: -1690.0,
          maxWinningStreakDays: 6,
          maxLosingStreakDays: 6,
          winRatio: 0.39,
          lossRatio: 0.61,
          totalWinDays: 12,
          totalLossDays: 19,
          expectancy: 180.16,
        },
        {
          strategy: "ORB_1",
          totalPNL: 322188.25,
          totalTrades: 116,
          positiveTrades: 45,
          negativeTrades: 71,
          accuracy: 38.79,
          winTradesRS: 696622.0,
          winTradePercentage: 38.79,
          lossTradesRS: -374433.75,
          lossTradePercentage: 61.21,
          rrRatio: 2.94,
          avgProfitPerWinTrades: 15480.488888888889,
          totalProfitOnWinDays: 696622.0,
          maxProfitOnWinDay: 125438.0,
          avgLossPerLossTrades: -5273.7147887323945,
          totalLossOnLossDays: -374433.75,
          maxLossOnLossDay: -28785.0,
          maxWinningStreakDays: 4,
          maxLosingStreakDays: 8,
          winRatio: 0.39,
          lossRatio: 0.61,
          totalWinDays: 45,
          totalLossDays: 71,
          expectancy: 2777.48,
        },
        {
          strategy: "PDI_MA_Daily",
          totalPNL: -17346.0,
          totalTrades: 3,
          positiveTrades: 0,
          negativeTrades: 3,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -17346.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -5782.0,
          totalLossOnLossDays: -17346.0,
          maxLossOnLossDay: -8870.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 3,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 3,
          expectancy: -5782.0,
        },
        {
          strategy: "PDI_MA_LLPC",
          totalPNL: 6150.0,
          totalTrades: 8,
          positiveTrades: 3,
          negativeTrades: 5,
          accuracy: 37.5,
          winTradesRS: 26770.0,
          winTradePercentage: 37.5,
          lossTradesRS: -20620.0,
          lossTradePercentage: 62.5,
          rrRatio: 2.16,
          avgProfitPerWinTrades: 8923.333333333334,
          totalProfitOnWinDays: 26770.0,
          maxProfitOnWinDay: 14585.0,
          avgLossPerLossTrades: -4124.0,
          totalLossOnLossDays: -20620.0,
          maxLossOnLossDay: -6000.0,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 5,
          winRatio: 0.38,
          lossRatio: 0.62,
          totalWinDays: 3,
          totalLossDays: 5,
          expectancy: 768.75,
        },
        {
          strategy: "PDI_MA_PC2",
          totalPNL: -2169.75,
          totalTrades: 75,
          positiveTrades: 29,
          negativeTrades: 46,
          accuracy: 38.67,
          winTradesRS: 153828.75,
          winTradePercentage: 38.67,
          lossTradesRS: -155998.5,
          lossTradePercentage: 61.33,
          rrRatio: 1.56,
          avgProfitPerWinTrades: 5304.439655172414,
          totalProfitOnWinDays: 153828.75,
          maxProfitOnWinDay: 33660.0,
          avgLossPerLossTrades: -3391.271739130435,
          totalLossOnLossDays: -155998.5,
          maxLossOnLossDay: -13720.0,
          maxWinningStreakDays: 4,
          maxLosingStreakDays: 9,
          winRatio: 0.39,
          lossRatio: 0.61,
          totalWinDays: 29,
          totalLossDays: 46,
          expectancy: -28.93,
        },
        {
          strategy: "PDI_MA_PC2_MA10",
          totalPNL: 28086.25,
          totalTrades: 4,
          positiveTrades: 2,
          negativeTrades: 2,
          accuracy: 50.0,
          winTradesRS: 31941.25,
          winTradePercentage: 50.0,
          lossTradesRS: -3855.0,
          lossTradePercentage: 50.0,
          rrRatio: 8.29,
          avgProfitPerWinTrades: 15970.625,
          totalProfitOnWinDays: 31941.25,
          maxProfitOnWinDay: 24356.25,
          avgLossPerLossTrades: -1927.5,
          totalLossOnLossDays: -3855.0,
          maxLossOnLossDay: -2460.0,
          maxWinningStreakDays: 2,
          maxLosingStreakDays: 1,
          winRatio: 0.5,
          lossRatio: 0.5,
          totalWinDays: 2,
          totalLossDays: 2,
          expectancy: 7021.56,
        },
        {
          strategy: "PDI_MA_PC5",
          totalPNL: 118225.75,
          totalTrades: 30,
          positiveTrades: 10,
          negativeTrades: 20,
          accuracy: 33.33,
          winTradesRS: 197821.75,
          winTradePercentage: 33.33,
          lossTradesRS: -79596.0,
          lossTradePercentage: 66.67,
          rrRatio: 4.97,
          avgProfitPerWinTrades: 19782.175,
          totalProfitOnWinDays: 197821.75,
          maxProfitOnWinDay: 83025.0,
          avgLossPerLossTrades: -3979.8,
          totalLossOnLossDays: -79596.0,
          maxLossOnLossDay: -8522.5,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 6,
          winRatio: 0.33,
          lossRatio: 0.67,
          totalWinDays: 10,
          totalLossDays: 20,
          expectancy: 3940.86,
        },
        {
          strategy: "PDI_MA_PC5_MA10",
          totalPNL: -1882.5,
          totalTrades: 1,
          positiveTrades: 0,
          negativeTrades: 1,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -1882.5,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -1882.5,
          totalLossOnLossDays: -1882.5,
          maxLossOnLossDay: -1882.5,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 1,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 1,
          expectancy: -1882.5,
        },
        {
          strategy: "PDI_MDI_LLPC",
          totalPNL: -5100.0,
          totalTrades: 1,
          positiveTrades: 0,
          negativeTrades: 1,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -5100.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -5100.0,
          totalLossOnLossDays: -5100.0,
          maxLossOnLossDay: -5100.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 1,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 1,
          expectancy: -5100.0,
        },
        {
          strategy: "PDI_MDI_PC2",
          totalPNL: 22318.25,
          totalTrades: 9,
          positiveTrades: 5,
          negativeTrades: 4,
          accuracy: 55.56,
          winTradesRS: 34132.5,
          winTradePercentage: 55.56,
          lossTradesRS: -11814.25,
          lossTradePercentage: 44.44,
          rrRatio: 2.31,
          avgProfitPerWinTrades: 6826.5,
          totalProfitOnWinDays: 34132.5,
          maxProfitOnWinDay: 18780.0,
          avgLossPerLossTrades: -2953.5625,
          totalLossOnLossDays: -11814.25,
          maxLossOnLossDay: -4010.0,
          maxWinningStreakDays: 4,
          maxLosingStreakDays: 2,
          winRatio: 0.56,
          lossRatio: 0.44,
          totalWinDays: 5,
          totalLossDays: 4,
          expectancy: 2479.81,
        },
        {
          strategy: "PDI_MDI_PC2_MA10",
          totalPNL: 15062.5,
          totalTrades: 1,
          positiveTrades: 1,
          negativeTrades: 0,
          accuracy: 100.0,
          winTradesRS: 15062.5,
          winTradePercentage: 100.0,
          lossTradesRS: 0.0,
          lossTradePercentage: 0.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 15062.5,
          totalProfitOnWinDays: 15062.5,
          maxProfitOnWinDay: 15062.5,
          avgLossPerLossTrades: 0.0,
          totalLossOnLossDays: 0.0,
          maxLossOnLossDay: 0.0,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 0,
          winRatio: 1.0,
          lossRatio: 0.0,
          totalWinDays: 1,
          totalLossDays: 0,
          expectancy: 15062.5,
        },
        {
          strategy: "PDI_MDI_PC5",
          totalPNL: 66914.75,
          totalTrades: 12,
          positiveTrades: 5,
          negativeTrades: 7,
          accuracy: 41.67,
          winTradesRS: 136140.0,
          winTradePercentage: 41.67,
          lossTradesRS: -69225.25,
          lossTradePercentage: 58.33,
          rrRatio: 2.75,
          avgProfitPerWinTrades: 27228.0,
          totalProfitOnWinDays: 136140.0,
          maxProfitOnWinDay: 83025.0,
          avgLossPerLossTrades: -9889.32142857143,
          totalLossOnLossDays: -69225.25,
          maxLossOnLossDay: -18861.25,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 2,
          winRatio: 0.42,
          lossRatio: 0.58,
          totalWinDays: 5,
          totalLossDays: 7,
          expectancy: 5576.23,
        },
        {
          strategy: "Wrong_trade",
          totalPNL: -1618.0,
          totalTrades: 2,
          positiveTrades: 0,
          negativeTrades: 2,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -1618.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -809.0,
          totalLossOnLossDays: -1618.0,
          maxLossOnLossDay: -1345.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 2,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 2,
          expectancy: -809.0,
        },
        {
          strategy: "_FDT_Very_far_OTM",
          totalPNL: 5061.0,
          totalTrades: 21,
          positiveTrades: 6,
          negativeTrades: 15,
          accuracy: 28.57,
          winTradesRS: 14830.0,
          winTradePercentage: 28.57,
          lossTradesRS: -9769.0,
          lossTradePercentage: 71.43,
          rrRatio: 3.8,
          avgProfitPerWinTrades: 2471.6666666666665,
          totalProfitOnWinDays: 14830.0,
          maxProfitOnWinDay: 5130.0,
          avgLossPerLossTrades: -651.2666666666667,
          totalLossOnLossDays: -9769.0,
          maxLossOnLossDay: -4740.0,
          maxWinningStreakDays: 4,
          maxLosingStreakDays: 9,
          winRatio: 0.29,
          lossRatio: 0.71,
          totalWinDays: 6,
          totalLossDays: 15,
          expectancy: 241.0,
        },
        {
          strategy: "unknown",
          totalPNL: -3268.0,
          totalTrades: 6,
          positiveTrades: 1,
          negativeTrades: 5,
          accuracy: 16.67,
          winTradesRS: 1020.0,
          winTradePercentage: 16.67,
          lossTradesRS: -4288.0,
          lossTradePercentage: 83.33,
          rrRatio: 1.19,
          avgProfitPerWinTrades: 1020.0,
          totalProfitOnWinDays: 1020.0,
          maxProfitOnWinDay: 1020.0,
          avgLossPerLossTrades: -857.6,
          totalLossOnLossDays: -4288.0,
          maxLossOnLossDay: -2228.0,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 4,
          winRatio: 0.17,
          lossRatio: 0.83,
          totalWinDays: 1,
          totalLossDays: 5,
          expectancy: -544.67,
        },
      ],
    },
    {
      asset: "bank",
      strategy_wise_metrics: [
        {
          strategy: "Blank",
          totalPNL: 47836.0,
          totalTrades: 12,
          positiveTrades: 4,
          negativeTrades: 8,
          accuracy: 33.33,
          winTradesRS: 114508.0,
          winTradePercentage: 33.33,
          lossTradesRS: -66672.0,
          lossTradePercentage: 66.67,
          rrRatio: 3.43,
          avgProfitPerWinTrades: 28627.0,
          totalProfitOnWinDays: 114508.0,
          maxProfitOnWinDay: 76913.0,
          avgLossPerLossTrades: -8334.0,
          totalLossOnLossDays: -66672.0,
          maxLossOnLossDay: -24094.0,
          maxWinningStreakDays: 2,
          maxLosingStreakDays: 3,
          winRatio: 0.33,
          lossRatio: 0.67,
          totalWinDays: 4,
          totalLossDays: 8,
          expectancy: 3986.33,
        },
        {
          strategy: "CRB_",
          totalPNL: -4636.0,
          totalTrades: 37,
          positiveTrades: 16,
          negativeTrades: 21,
          accuracy: 43.24,
          winTradesRS: 3742.0,
          winTradePercentage: 43.24,
          lossTradesRS: -8378.0,
          lossTradePercentage: 56.76,
          rrRatio: 0.59,
          avgProfitPerWinTrades: 233.875,
          totalProfitOnWinDays: 3742.0,
          maxProfitOnWinDay: 881.0,
          avgLossPerLossTrades: -398.95238095238096,
          totalLossOnLossDays: -8378.0,
          maxLossOnLossDay: -1206.0,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 6,
          winRatio: 0.43,
          lossRatio: 0.57,
          totalWinDays: 16,
          totalLossDays: 21,
          expectancy: -125.3,
        },
        {
          strategy: "FDT_",
          totalPNL: 23189.0,
          totalTrades: 16,
          positiveTrades: 9,
          negativeTrades: 7,
          accuracy: 56.25,
          winTradesRS: 40542.0,
          winTradePercentage: 56.25,
          lossTradesRS: -17353.0,
          lossTradePercentage: 43.75,
          rrRatio: 1.82,
          avgProfitPerWinTrades: 4504.666666666667,
          totalProfitOnWinDays: 40542.0,
          maxProfitOnWinDay: 12347.0,
          avgLossPerLossTrades: -2479.0,
          totalLossOnLossDays: -17353.0,
          maxLossOnLossDay: -6778.0,
          maxWinningStreakDays: 4,
          maxLosingStreakDays: 2,
          winRatio: 0.56,
          lossRatio: 0.44,
          totalWinDays: 9,
          totalLossDays: 7,
          expectancy: 1449.31,
        },
        {
          strategy: "Gamma",
          totalPNL: -345.0,
          totalTrades: 1,
          positiveTrades: 0,
          negativeTrades: 1,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -345.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -345.0,
          totalLossOnLossDays: -345.0,
          maxLossOnLossDay: -345.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 1,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 1,
          expectancy: -345.0,
        },
        {
          strategy: "HE_PC2",
          totalPNL: 14749.25,
          totalTrades: 57,
          positiveTrades: 18,
          negativeTrades: 39,
          accuracy: 31.58,
          winTradesRS: 126879.5,
          winTradePercentage: 31.58,
          lossTradesRS: -112130.25,
          lossTradePercentage: 68.42,
          rrRatio: 2.45,
          avgProfitPerWinTrades: 7048.861111111111,
          totalProfitOnWinDays: 126879.5,
          maxProfitOnWinDay: 36573.0,
          avgLossPerLossTrades: -2875.1346153846152,
          totalLossOnLossDays: -112130.25,
          maxLossOnLossDay: -32868.0,
          maxWinningStreakDays: 6,
          maxLosingStreakDays: 9,
          winRatio: 0.32,
          lossRatio: 0.68,
          totalWinDays: 18,
          totalLossDays: 39,
          expectancy: 258.76,
        },
        {
          strategy: "HE_PC2_MA10",
          totalPNL: 21120.0,
          totalTrades: 1,
          positiveTrades: 1,
          negativeTrades: 0,
          accuracy: 100.0,
          winTradesRS: 21120.0,
          winTradePercentage: 100.0,
          lossTradesRS: 0.0,
          lossTradePercentage: 0.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 21120.0,
          totalProfitOnWinDays: 21120.0,
          maxProfitOnWinDay: 21120.0,
          avgLossPerLossTrades: 0.0,
          totalLossOnLossDays: 0.0,
          maxLossOnLossDay: 0.0,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 0,
          winRatio: 1.0,
          lossRatio: 0.0,
          totalWinDays: 1,
          totalLossDays: 0,
          expectancy: 21120.0,
        },
        {
          strategy: "HE_PC5",
          totalPNL: 5144.75,
          totalTrades: 9,
          positiveTrades: 3,
          negativeTrades: 6,
          accuracy: 33.33,
          winTradesRS: 24210.0,
          winTradePercentage: 33.33,
          lossTradesRS: -19065.25,
          lossTradePercentage: 66.67,
          rrRatio: 2.54,
          avgProfitPerWinTrades: 8070.0,
          totalProfitOnWinDays: 24210.0,
          maxProfitOnWinDay: 11040.0,
          avgLossPerLossTrades: -3177.5416666666665,
          totalLossOnLossDays: -19065.25,
          maxLossOnLossDay: -5085.0,
          maxWinningStreakDays: 2,
          maxLosingStreakDays: 2,
          winRatio: 0.33,
          lossRatio: 0.67,
          totalWinDays: 3,
          totalLossDays: 6,
          expectancy: 571.64,
        },
        {
          strategy: "HHPC_LLPC",
          totalPNL: -5301.0,
          totalTrades: 1,
          positiveTrades: 0,
          negativeTrades: 1,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -5301.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -5301.0,
          totalLossOnLossDays: -5301.0,
          maxLossOnLossDay: -5301.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 1,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 1,
          expectancy: -5301.0,
        },
        {
          strategy: "HHPC_PC2",
          totalPNL: -5013.0,
          totalTrades: 11,
          positiveTrades: 3,
          negativeTrades: 8,
          accuracy: 27.27,
          winTradesRS: 44309.0,
          winTradePercentage: 27.27,
          lossTradesRS: -49322.0,
          lossTradePercentage: 72.73,
          rrRatio: 2.4,
          avgProfitPerWinTrades: 14769.666666666666,
          totalProfitOnWinDays: 44309.0,
          maxProfitOnWinDay: 25068.0,
          avgLossPerLossTrades: -6165.25,
          totalLossOnLossDays: -49322.0,
          maxLossOnLossDay: -19785.0,
          maxWinningStreakDays: 2,
          maxLosingStreakDays: 4,
          winRatio: 0.27,
          lossRatio: 0.73,
          totalWinDays: 3,
          totalLossDays: 8,
          expectancy: -455.73,
        },
        {
          strategy: "HHPC_PC5",
          totalPNL: -27522.75,
          totalTrades: 3,
          positiveTrades: 0,
          negativeTrades: 3,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -27522.75,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -9174.25,
          totalLossOnLossDays: -27522.75,
          maxLossOnLossDay: -13761.75,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 3,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 3,
          expectancy: -9174.25,
        },
        {
          strategy: "HHPC_weekly",
          totalPNL: -817.5,
          totalTrades: 1,
          positiveTrades: 0,
          negativeTrades: 1,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -817.5,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -817.5,
          totalLossOnLossDays: -817.5,
          maxLossOnLossDay: -817.5,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 1,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 1,
          expectancy: -817.5,
        },
        {
          strategy: "ORB2",
          totalPNL: 2722.0,
          totalTrades: 32,
          positiveTrades: 12,
          negativeTrades: 20,
          accuracy: 37.5,
          winTradesRS: 13594.0,
          winTradePercentage: 37.5,
          lossTradesRS: -10872.0,
          lossTradePercentage: 62.5,
          rrRatio: 2.08,
          avgProfitPerWinTrades: 1132.8333333333333,
          totalProfitOnWinDays: 13594.0,
          maxProfitOnWinDay: 3580.0,
          avgLossPerLossTrades: -543.6,
          totalLossOnLossDays: -10872.0,
          maxLossOnLossDay: -1214.0,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 5,
          winRatio: 0.38,
          lossRatio: 0.62,
          totalWinDays: 12,
          totalLossDays: 20,
          expectancy: 85.06,
        },
        {
          strategy: "ORB_1",
          totalPNL: -46738.0,
          totalTrades: 66,
          positiveTrades: 23,
          negativeTrades: 43,
          accuracy: 34.85,
          winTradesRS: 112965.0,
          winTradePercentage: 34.85,
          lossTradesRS: -159703.0,
          lossTradePercentage: 65.15,
          rrRatio: 1.32,
          avgProfitPerWinTrades: 4911.521739130435,
          totalProfitOnWinDays: 112965.0,
          maxProfitOnWinDay: 23055.0,
          avgLossPerLossTrades: -3714.0232558139537,
          totalLossOnLossDays: -159703.0,
          maxLossOnLossDay: -27459.0,
          maxWinningStreakDays: 5,
          maxLosingStreakDays: 9,
          winRatio: 0.35,
          lossRatio: 0.65,
          totalWinDays: 23,
          totalLossDays: 43,
          expectancy: -708.15,
        },
        {
          strategy: "PDI_MA_LLPC",
          totalPNL: -46497.0,
          totalTrades: 11,
          positiveTrades: 2,
          negativeTrades: 9,
          accuracy: 18.18,
          winTradesRS: 9257.0,
          winTradePercentage: 18.18,
          lossTradesRS: -55754.0,
          lossTradePercentage: 81.82,
          rrRatio: 0.75,
          avgProfitPerWinTrades: 4628.5,
          totalProfitOnWinDays: 9257.0,
          maxProfitOnWinDay: 4716.0,
          avgLossPerLossTrades: -6194.888888888889,
          totalLossOnLossDays: -55754.0,
          maxLossOnLossDay: -11241.0,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 7,
          winRatio: 0.18,
          lossRatio: 0.82,
          totalWinDays: 2,
          totalLossDays: 9,
          expectancy: -4227.0,
        },
        {
          strategy: "PDI_MA_PC2",
          totalPNL: -13982.5,
          totalTrades: 56,
          positiveTrades: 18,
          negativeTrades: 38,
          accuracy: 32.14,
          winTradesRS: 169729.0,
          winTradePercentage: 32.14,
          lossTradesRS: -183711.5,
          lossTradePercentage: 67.86,
          rrRatio: 1.95,
          avgProfitPerWinTrades: 9429.388888888889,
          totalProfitOnWinDays: 169729.0,
          maxProfitOnWinDay: 36629.0,
          avgLossPerLossTrades: -4834.513157894737,
          totalLossOnLossDays: -183711.5,
          maxLossOnLossDay: -16965.0,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 5,
          winRatio: 0.32,
          lossRatio: 0.68,
          totalWinDays: 18,
          totalLossDays: 38,
          expectancy: -249.69,
        },
        {
          strategy: "PDI_MA_PC5",
          totalPNL: -12234.75,
          totalTrades: 10,
          positiveTrades: 3,
          negativeTrades: 7,
          accuracy: 30.0,
          winTradesRS: 15389.0,
          winTradePercentage: 30.0,
          lossTradesRS: -27623.75,
          lossTradePercentage: 70.0,
          rrRatio: 1.3,
          avgProfitPerWinTrades: 5129.666666666667,
          totalProfitOnWinDays: 15389.0,
          maxProfitOnWinDay: 10055.0,
          avgLossPerLossTrades: -3946.25,
          totalLossOnLossDays: -27623.75,
          maxLossOnLossDay: -7332.0,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 5,
          winRatio: 0.3,
          lossRatio: 0.7,
          totalWinDays: 3,
          totalLossDays: 7,
          expectancy: -1223.47,
        },
        {
          strategy: "PDI_MDI_LLPC",
          totalPNL: -5016.0,
          totalTrades: 2,
          positiveTrades: 1,
          negativeTrades: 1,
          accuracy: 50.0,
          winTradesRS: 4716.0,
          winTradePercentage: 50.0,
          lossTradesRS: -9732.0,
          lossTradePercentage: 50.0,
          rrRatio: 0.48,
          avgProfitPerWinTrades: 4716.0,
          totalProfitOnWinDays: 4716.0,
          maxProfitOnWinDay: 4716.0,
          avgLossPerLossTrades: -9732.0,
          totalLossOnLossDays: -9732.0,
          maxLossOnLossDay: -9732.0,
          maxWinningStreakDays: 1,
          maxLosingStreakDays: 1,
          winRatio: 0.5,
          lossRatio: 0.5,
          totalWinDays: 1,
          totalLossDays: 1,
          expectancy: -2508.0,
        },
        {
          strategy: "PDI_MDI_PC2",
          totalPNL: -4320.5,
          totalTrades: 10,
          positiveTrades: 6,
          negativeTrades: 4,
          accuracy: 60.0,
          winTradesRS: 21660.0,
          winTradePercentage: 60.0,
          lossTradesRS: -25980.5,
          lossTradePercentage: 40.0,
          rrRatio: 0.56,
          avgProfitPerWinTrades: 3610.0,
          totalProfitOnWinDays: 21660.0,
          maxProfitOnWinDay: 6363.0,
          avgLossPerLossTrades: -6495.125,
          totalLossOnLossDays: -25980.5,
          maxLossOnLossDay: -12847.5,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 1,
          winRatio: 0.6,
          lossRatio: 0.4,
          totalWinDays: 6,
          totalLossDays: 4,
          expectancy: -432.05,
        },
        {
          strategy: "PDI_MDI_PC5",
          totalPNL: -20210.25,
          totalTrades: 3,
          positiveTrades: 0,
          negativeTrades: 3,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -20210.25,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -6736.75,
          totalLossOnLossDays: -20210.25,
          maxLossOnLossDay: -12111.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 3,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 3,
          expectancy: -6736.75,
        },
        {
          strategy: "Wrong_trade",
          totalPNL: -9.0,
          totalTrades: 1,
          positiveTrades: 0,
          negativeTrades: 1,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -9.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -9.0,
          totalLossOnLossDays: -9.0,
          maxLossOnLossDay: -9.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 1,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 1,
          expectancy: -9.0,
        },
        {
          strategy: "unknown",
          totalPNL: -858.0,
          totalTrades: 1,
          positiveTrades: 0,
          negativeTrades: 1,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -858.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -858.0,
          totalLossOnLossDays: -858.0,
          maxLossOnLossDay: -858.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 1,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 1,
          expectancy: -858.0,
        },
      ],
    },
    {
      asset: "stock",
      strategy_wise_metrics: [
        {
          strategy: "Blank",
          totalPNL: 752089.0,
          totalTrades: 926,
          positiveTrades: 223,
          negativeTrades: 703,
          accuracy: 24.08,
          winTradesRS: 2746968.0,
          winTradePercentage: 24.08,
          lossTradesRS: -1994879.0,
          lossTradePercentage: 75.92,
          rrRatio: 4.34,
          avgProfitPerWinTrades: 12318.242152466368,
          totalProfitOnWinDays: 2746968.0,
          maxProfitOnWinDay: 87750.0,
          avgLossPerLossTrades: -2837.6657183499287,
          totalLossOnLossDays: -1994879.0,
          maxLossOnLossDay: -26180.0,
          maxWinningStreakDays: 13,
          maxLosingStreakDays: 50,
          winRatio: 0.24,
          lossRatio: 0.76,
          totalWinDays: 223,
          totalLossDays: 703,
          expectancy: 812.19,
        },
        {
          strategy: "FDT_",
          totalPNL: -2090.0,
          totalTrades: 2,
          positiveTrades: 0,
          negativeTrades: 2,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -2090.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -1045.0,
          totalLossOnLossDays: -2090.0,
          maxLossOnLossDay: -1190.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 2,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 2,
          expectancy: -1045.0,
        },
        {
          strategy: "HE_PC2",
          totalPNL: 229241.39999999997,
          totalTrades: 843,
          positiveTrades: 245,
          negativeTrades: 598,
          accuracy: 29.06,
          winTradesRS: 4007168.1,
          winTradePercentage: 29.06,
          lossTradesRS: -3777926.7,
          lossTradePercentage: 70.94,
          rrRatio: 2.59,
          avgProfitPerWinTrades: 16355.788163265306,
          totalProfitOnWinDays: 4007168.1,
          maxProfitOnWinDay: 324415.0,
          avgLossPerLossTrades: -6317.603177257525,
          totalLossOnLossDays: -3777926.7,
          maxLossOnLossDay: -30850.0,
          maxWinningStreakDays: 7,
          maxLosingStreakDays: 28,
          winRatio: 0.29,
          lossRatio: 0.71,
          totalWinDays: 245,
          totalLossDays: 598,
          expectancy: 271.94,
        },
        {
          strategy: "HE_PC2_MA10",
          totalPNL: -18015.0,
          totalTrades: 2,
          positiveTrades: 0,
          negativeTrades: 2,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -18015.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -9007.5,
          totalLossOnLossDays: -18015.0,
          maxLossOnLossDay: -9140.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 2,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 2,
          expectancy: -9007.5,
        },
        {
          strategy: "HHPC_PC2",
          totalPNL: 95895.5,
          totalTrades: 182,
          positiveTrades: 69,
          negativeTrades: 113,
          accuracy: 37.91,
          winTradesRS: 661173.1,
          winTradePercentage: 37.91,
          lossTradesRS: -565277.6,
          lossTradePercentage: 62.09,
          rrRatio: 1.92,
          avgProfitPerWinTrades: 9582.21884057971,
          totalProfitOnWinDays: 661173.1,
          maxProfitOnWinDay: 43218.75,
          avgLossPerLossTrades: -5002.456637168141,
          totalLossOnLossDays: -565277.6,
          maxLossOnLossDay: -14945.0,
          maxWinningStreakDays: 6,
          maxLosingStreakDays: 10,
          winRatio: 0.38,
          lossRatio: 0.62,
          totalWinDays: 69,
          totalLossDays: 113,
          expectancy: 526.9,
        },
        {
          strategy: "HHPC_PC5",
          totalPNL: 14232.0,
          totalTrades: 40,
          positiveTrades: 15,
          negativeTrades: 25,
          accuracy: 37.5,
          winTradesRS: 152732.0,
          winTradePercentage: 37.5,
          lossTradesRS: -138500.0,
          lossTradePercentage: 62.5,
          rrRatio: 1.84,
          avgProfitPerWinTrades: 10182.133333333333,
          totalProfitOnWinDays: 152732.0,
          maxProfitOnWinDay: 39270.0,
          avgLossPerLossTrades: -5540.0,
          totalLossOnLossDays: -138500.0,
          maxLossOnLossDay: -13490.0,
          maxWinningStreakDays: 3,
          maxLosingStreakDays: 7,
          winRatio: 0.38,
          lossRatio: 0.62,
          totalWinDays: 15,
          totalLossDays: 25,
          expectancy: 355.8,
        },
        {
          strategy: "Manual",
          totalPNL: -750.0,
          totalTrades: 1,
          positiveTrades: 0,
          negativeTrades: 1,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -750.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -750.0,
          totalLossOnLossDays: -750.0,
          maxLossOnLossDay: -750.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 1,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 1,
          expectancy: -750.0,
        },
        {
          strategy: "ORB_1",
          totalPNL: -500.0,
          totalTrades: 1,
          positiveTrades: 0,
          negativeTrades: 1,
          accuracy: 0.0,
          winTradesRS: 0.0,
          winTradePercentage: 0.0,
          lossTradesRS: -500.0,
          lossTradePercentage: 100.0,
          rrRatio: 0.0,
          avgProfitPerWinTrades: 0.0,
          totalProfitOnWinDays: 0.0,
          maxProfitOnWinDay: 0.0,
          avgLossPerLossTrades: -500.0,
          totalLossOnLossDays: -500.0,
          maxLossOnLossDay: -500.0,
          maxWinningStreakDays: 0,
          maxLosingStreakDays: 1,
          winRatio: 0.0,
          lossRatio: 1.0,
          totalWinDays: 0,
          totalLossDays: 1,
          expectancy: -500.0,
        },
        {
          strategy: "PDI_MA_PC2",
          totalPNL: 1199839.85,
          totalTrades: 927,
          positiveTrades: 344,
          negativeTrades: 583,
          accuracy: 37.11,
          winTradesRS: 3835199.4,
          winTradePercentage: 37.11,
          lossTradesRS: -2635359.55,
          lossTradePercentage: 62.89,
          rrRatio: 2.47,
          avgProfitPerWinTrades: 11148.835465116279,
          totalProfitOnWinDays: 3835199.4,
          maxProfitOnWinDay: 111037.5,
          avgLossPerLossTrades: -4520.342281303601,
          totalLossOnLossDays: -2635359.55,
          maxLossOnLossDay: -21450.0,
          maxWinningStreakDays: 15,
          maxLosingStreakDays: 18,
          winRatio: 0.37,
          lossRatio: 0.63,
          totalWinDays: 344,
          totalLossDays: 583,
          expectancy: 1294.33,
        },
        {
          strategy: "PDI_MDI_PC2",
          totalPNL: 399877.0,
          totalTrades: 293,
          positiveTrades: 106,
          negativeTrades: 187,
          accuracy: 36.18,
          winTradesRS: 1332016.45,
          winTradePercentage: 36.18,
          lossTradesRS: -932139.45,
          lossTradePercentage: 63.82,
          rrRatio: 2.52,
          avgProfitPerWinTrades: 12566.1929245283,
          totalProfitOnWinDays: 1332016.45,
          maxProfitOnWinDay: 111960.0,
          avgLossPerLossTrades: -4984.702941176471,
          totalLossOnLossDays: -932139.45,
          maxLossOnLossDay: -18950.0,
          maxWinningStreakDays: 5,
          maxLosingStreakDays: 9,
          winRatio: 0.36,
          lossRatio: 0.64,
          totalWinDays: 106,
          totalLossDays: 187,
          expectancy: 1364.77,
        },
      ],
    },
  ],
  year_wise_strategy_wise_monthly_pnl: [
    {
      year: "2023",
      pnl_data: [
        {
          strategy: "Blank",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: -17143.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: " FDT Very far OTM",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 5061.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "CRB ",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: -5013.0,
              month: "Sep",
            },
            {
              pnl: 1895.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "FDT ",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 29653.0,
              month: "Sep",
            },
            {
              pnl: 78884.0,
              month: "Oct",
            },
            {
              pnl: 9756.0,
              month: "Nov",
            },
            {
              pnl: -376.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HE",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 39851.0,
              month: "Nov",
            },
            {
              pnl: 123641.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HHPC PC2",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: -2128.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "Heavy Entry  Very Far OTM",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 7088.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "ORB 1 ",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 29594.0,
              month: "Sep",
            },
            {
              pnl: 10468.0,
              month: "Oct",
            },
            {
              pnl: -9696.0,
              month: "Nov",
            },
            {
              pnl: 41316.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "ORB2 ",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 2071.0,
              month: "Sep",
            },
            {
              pnl: 6236.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "Wrong trade",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: -1627.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "unknown",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: -393.0,
              month: "Aug",
            },
            {
              pnl: -2329.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: -1404.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
      ],
    },
    {
      year: "2024",
      pnl_data: [
        {
          strategy: "Blank",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: -63192.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 980426.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "FDT Daily",
          monthly_pnl: [
            {
              pnl: -61847.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "Gamma",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: -11432.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HE",
          monthly_pnl: [
            {
              pnl: 12708.0,
              month: "Jan",
            },
            {
              pnl: -4912.0,
              month: "Feb",
            },
            {
              pnl: -25290.0,
              month: "Mar",
            },
            {
              pnl: -84654.0,
              month: "Apr",
            },
            {
              pnl: 275901.0,
              month: "May",
            },
            {
              pnl: -193993.0,
              month: "Jun",
            },
            {
              pnl: -66310.0,
              month: "Jul",
            },
            {
              pnl: 270151.1,
              month: "Aug",
            },
            {
              pnl: 8046.05000000001,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HE ",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: -9938.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HE PC2",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 2939.0,
              month: "May",
            },
            {
              pnl: -20728.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HE PC2 ",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 991.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HE PC2  ",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 17820.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HE PC2 MA10",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 23485.0,
              month: "May",
            },
            {
              pnl: -18015.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HE PC5",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: -6751.0,
              month: "Apr",
            },
            {
              pnl: 4913.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HE_PC2",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: -1562.0,
              month: "Jul",
            },
            {
              pnl: -5379.0,
              month: "Aug",
            },
            {
              pnl: 15983.25,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HE_PC2_MA10",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: -315.0,
              month: "Jun",
            },
            {
              pnl: 2845.0,
              month: "Jul",
            },
            {
              pnl: 78360.5,
              month: "Aug",
            },
            {
              pnl: -3780.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HE_PC5",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: -7504.0,
              month: "Jul",
            },
            {
              pnl: -29622.5,
              month: "Aug",
            },
            {
              pnl: 38373.5,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HHPC",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: -1273.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HHPC  LLPC",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: -7876.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HHPC PC2",
          monthly_pnl: [
            {
              pnl: 55648.0,
              month: "Jan",
            },
            {
              pnl: 21824.0,
              month: "Feb",
            },
            {
              pnl: 5901.0,
              month: "Mar",
            },
            {
              pnl: 45044.0,
              month: "Apr",
            },
            {
              pnl: -19785.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HHPC PC5",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: -5240.0,
              month: "Feb",
            },
            {
              pnl: 1502.0,
              month: "Mar",
            },
            {
              pnl: 36873.0,
              month: "Apr",
            },
            {
              pnl: 24580.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HHPC_PC2",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: -5095.0,
              month: "Jul",
            },
            {
              pnl: 15627.0,
              month: "Aug",
            },
            {
              pnl: -6258.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HHPC_PC2_MA10",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 92705.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HHPC_PC5",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: -24012.75,
              month: "Aug",
            },
            {
              pnl: -47286.25,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HHPC_PC5_MA10",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: -9559.0,
              month: "Jul",
            },
            {
              pnl: -21946.25,
              month: "Aug",
            },
            {
              pnl: 6947.5,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HHPC_PCL2",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 2131.0,
              month: "Jul",
            },
            {
              pnl: 29250.75,
              month: "Aug",
            },
            {
              pnl: -51327.25,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HHPC_PCL5",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: -24973.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "HHPC_weekly",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: -1237.5,
              month: "Aug",
            },
            {
              pnl: -5497.5,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "Manual",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: -750.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "ORB 1 ",
          monthly_pnl: [
            {
              pnl: 499.0,
              month: "Jan",
            },
            {
              pnl: -24450.0,
              month: "Feb",
            },
            {
              pnl: -37796.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "ORB1",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: -2115.0,
              month: "Mar",
            },
            {
              pnl: 43940.0,
              month: "Apr",
            },
            {
              pnl: 126175.0,
              month: "May",
            },
            {
              pnl: -48615.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "ORB_1",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 19002.0,
              month: "Jun",
            },
            {
              pnl: 4428.0,
              month: "Jul",
            },
            {
              pnl: -23551.0,
              month: "Aug",
            },
            {
              pnl: 145751.25,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI.MA",
          monthly_pnl: [
            {
              pnl: 7640.0,
              month: "Jan",
            },
            {
              pnl: -713.0,
              month: "Feb",
            },
            {
              pnl: 122294.0,
              month: "Mar",
            },
            {
              pnl: 21154.0,
              month: "Apr",
            },
            {
              pnl: 464720.0,
              month: "May",
            },
            {
              pnl: 170271.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI.MA  LLPC",
          monthly_pnl: [
            {
              pnl: -6750.0,
              month: "Jan",
            },
            {
              pnl: -33597.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI.MA Daily",
          monthly_pnl: [
            {
              pnl: -17346.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI.MA PC2",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 49758.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI.MA PC2 MA10",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: -1395.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI.MA PC5",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 8440.0,
              month: "Apr",
            },
            {
              pnl: 78153.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI.MDI",
          monthly_pnl: [
            {
              pnl: 56951.0,
              month: "Jan",
            },
            {
              pnl: -9502.0,
              month: "Feb",
            },
            {
              pnl: 22090.0,
              month: "Mar",
            },
            {
              pnl: -21515.0,
              month: "Apr",
            },
            {
              pnl: 212294.0,
              month: "May",
            },
            {
              pnl: -22145.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI.MDI LLPC",
          monthly_pnl: [
            {
              pnl: 4716.0,
              month: "Jan",
            },
            {
              pnl: -14832.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI.MDI PC2",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 3336.0,
              month: "May",
            },
            {
              pnl: 36129.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI.MDI PC5",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 76882.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI.MDIPC2",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 2520.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI.MDIPC5",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 7935.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 0.0,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI_MA",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: -20115.0,
              month: "Jun",
            },
            {
              pnl: 61433.0,
              month: "Jul",
            },
            {
              pnl: 184358.65,
              month: "Aug",
            },
            {
              pnl: 121625.45,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI_MA_PC2",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: -10464.0,
              month: "Jul",
            },
            {
              pnl: 4915.5,
              month: "Aug",
            },
            {
              pnl: 6810.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI_MA_PC2_MA10",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 7585.0,
              month: "Aug",
            },
            {
              pnl: 21896.25,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI_MA_PC5",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 14024.0,
              month: "Jun",
            },
            {
              pnl: -10597.0,
              month: "Jul",
            },
            {
              pnl: -27286.75,
              month: "Aug",
            },
            {
              pnl: 43257.75,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI_MA_PC5_MA10",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: -1882.5,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI_MDI",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: -4172.0,
              month: "Jun",
            },
            {
              pnl: -45835.0,
              month: "Jul",
            },
            {
              pnl: 265958.8,
              month: "Aug",
            },
            {
              pnl: -65792.55,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI_MDI_PC2",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 405.0,
              month: "Aug",
            },
            {
              pnl: -12847.5,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI_MDI_PC2_MA10",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 0.0,
              month: "Jul",
            },
            {
              pnl: 15062.5,
              month: "Aug",
            },
            {
              pnl: 0.0,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
        {
          strategy: "PDI_MDI_PC5",
          monthly_pnl: [
            {
              pnl: 0.0,
              month: "Jan",
            },
            {
              pnl: 0.0,
              month: "Feb",
            },
            {
              pnl: 0.0,
              month: "Mar",
            },
            {
              pnl: 0.0,
              month: "Apr",
            },
            {
              pnl: 0.0,
              month: "May",
            },
            {
              pnl: 0.0,
              month: "Jun",
            },
            {
              pnl: 959.0,
              month: "Jul",
            },
            {
              pnl: -36421.75,
              month: "Aug",
            },
            {
              pnl: -2649.75,
              month: "Sep",
            },
            {
              pnl: 0.0,
              month: "Oct",
            },
            {
              pnl: 0.0,
              month: "Nov",
            },
            {
              pnl: 0.0,
              month: "Dec",
            },
          ],
        },
      ],
    },
  ],
  weekdays_pnl: [
    {
      day: "Monday",
      pnl: 459027.0,
    },
    {
      day: "Tuesday",
      pnl: -69644.5,
    },
    {
      day: "Wednesday",
      pnl: 573922.05,
    },
    {
      day: "Thursday",
      pnl: 465051.4,
    },
    {
      day: "Friday",
      pnl: 2095378.05,
    },
    {
      day: "Saturday",
      pnl: -23711.0,
    },
  ],
  datetime: "2024-10-09T06:24:08.051830",
};
